<template>
  <div>
    <transition name="fade-slide">
      <div v-if="showSuccess" class="success-toast" role="status">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
      </div>
    </transition>
    <v-container fluid>
      <!-- <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar dark class="header-title" elevation="0">
          <v-toolbar-title class="title">Intent Session Detail</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <h2 class="heading-text">Intent Session Information</h2>

      <div class="mt-2 mb-4">
        <hr />
      </div>

      <v-card class="card2">
        <v-row class="items-center">
          <v-col cols="12" sm="3">
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                Intent Session Name
              </label>
              <span style="color: red; margin-left: 4px;">*</span>
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>Name this intent session to easily identify its purpose.</span>
              </v-tooltip>
            </div>
            <v-text-field
              id="intentsessionname-intentsessiondetail"
              v-model="Request.Name"
              variant="outlined"
              density="comfortable"
              placeholder="Intent Session Name"
              hide-details
              color="grey"
            />
          </v-col>

          <!-- Priority -->
          <v-col cols="12" sm="2">
            <div class="mb-1 d-flex align-center" style="gap: 4px">
              <label for="priority" class="text-sm font-medium text-gray-700">Priority</label>
              <v-tooltip location="top" max-width="240px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>If a user’s input matches more than one intent session, the one with the higher priority will be selected.</span>
              </v-tooltip>
            </div>
            <v-text-field
              id="score-intentsessiondetail"
              v-model="Request.Score"
              variant="outlined"
              density="comfortable"
              placeholder="Priority"
              hide-details
              color="grey"
              @keypress="isNumberpositive($event)"
            />
          </v-col>

          <v-col col="6" sm="1" style="display: flex; justify-content: center;">
            <div class="action-divider"></div>
          </v-col>

          <!-- Use Memory -->
          <v-col cols="12" sm="3">
            <div class="card-box use-memory-card" :class="Request.UseMemory ? 'state-on' : 'state-off'">
              <div class="cart-top">
                <img src="@/assets/Frame.svg" alt="img" width="18" height="18" />
                <span style="font-weight: 600; font-size: 12px; color: #171717;">Use Memory</span>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>If enabled, chat history will be included to help identify the user’s intent.</span>
                </v-tooltip>
              </div>
              <div class="cart-bottom mt-1">
                <span style="font-weight: 500; font-size: 11px; color: #171717;">Enable memory for this intent</span>
                <v-switch v-model="Request.UseMemory" class="memory-switch" hide-details></v-switch>
              </div>
            </div>
          </v-col>

          <!-- Use Base Prompt -->
          <v-col cols="12" sm="3">
            <div class="card-box use-memory-card" :class="Request.UseBasePrompt ? 'state-on' : 'state-off'">
              <div class="cart-top">
                <img src="@/assets/fluent_prompt-16-filled.svg" alt="img" width="18" height="18" />
                <span style="font-weight: 600; font-size: 12px; color: #171717;">Use Base Prompt</span>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>If enabled, it combines the base prompt from the main model with the intent’s action prompt.</span>
                </v-tooltip>
              </div>
              <div class="cart-bottom mt-1">
                <span style="font-weight: 500; font-size: 9px; color: #171717;">Merge base prompt with action prompt</span>
                <v-switch v-model="Request.UseBasePrompt" @change="toggleAllMergePrompt" class="memory-switch" hide-details></v-switch>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-row style="margin-top: -28px;">
        <v-col cols="12" sm="12" md="12">
          <div class="mb-3 d-flex align-center mt-3" style="gap: 4px">
            <img src="@/assets/picen.svg" alt="img" width="16" height="16" />
            <h4 for="label" class="heading-text">
              Set Prompt for Intent Detection
            </h4>
          </div>
          <v-textarea
            id="prompt-intentsessiondetail"
            variant="plain"
            v-model="Request.PromptSession"
            placeholder="Enter a prompte"
            hide-details="auto"
            class="textarea-style"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <div class="intent-panel-body" :class="showDialog ? 'intent-panel-open' : 'intent-panel-closed'" @click="showDialog = !showDialog">
            <div class="intent-left">
              <img :src="showDialog ? iconGoalsWhite : iconGoalsColor" alt="Example" width="16" height="16" />
              <span :style="{ color: showDialog ? '#ffffff' : '#171717' }" class="example-text">Example Questions</span>
            </div>
            <button type="button" class="intent-right">
              <img
                v-if="!showDialog"
                src="@/assets/lets-icons_arrow-drop-down.svg"
                alt="expand"
                width="16"
                height="16"
              />
              <img
                v-else
                src="@/assets/lets-icons_arrow-drop-up.svg"
                alt="collapse"
                width="16"
                height="16"
              />
            </button>
          </div>
        </v-col>
      </v-row>

      <!-- Example Question Card -->
      <v-card class="card-design mt-6" v-show="showDialog">
        <v-card-title>
          <div class="card-header">
            <div class="card-title">
              <img src="@/assets/message.svg" alt="img" width="16" height="16" />
              <span style="font-weight: 700; color: #171717; font-size: 14px;">Example Questions</span>
            </div>
            <div class="card-title">
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <button @click="downloadTemplate()" class="template-btn" v-bind="props">
                    <img src="@/assets/lucide_download.svg" alt="img" width="16" height="16" />
                    <span style="color: #C32E0E; font-size: 13px">Template</span>
                  </button>
                </template>
                <span>Download Templates</span>
              </v-tooltip>
              
              <DragDropFile
                id="uploadfile-intentsessiondetail"
                :dialog="true"
                :DragDrop="false"
                :ShowListFile="false"
                accept=".xlsx"
                @filesUploaded="processUpload($event)"
                :allowType="[
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                ]"
                class="UploadFile"
              />
            </div>
          </div>
        </v-card-title>
        <div style="margin-top: -10px;">
          <hr />
        </div>

        <div class="example-questions-wrapper">
          <div
            v-for="(item, index) in Intent"
            :key="'example-' + index"
            class="example-input-row"
          >
            <div class="example-info-icon">{{ index + 1 }}</div>
            <input
              :id="'examplequestion-intentsessiondetail-' + index"
              v-model="item.text"
              type="text"
              class="example-input"
              placeholder="Enter an example question for this intent"
              @keypress="isEnter($event, index)"
              @keypress.enter="newLineEnter(index)"
              @paste="onPaste(index, $event)"
              @keyup.delete="CheckDeleteIntent(index, item.text)"
            />
            <button
              :id="'button-delete-example-intentsessiondetail-' + index"
              v-show="index + 1 < Intent.length"
              class="example-delete-btn"
              @click="Intent.splice(index, 1)"
              type="button"
              aria-label="Delete example question"
            >
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/Group.svg"
                    alt="info"
                    width="20"
                    height="17"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>Delete</span>
              </v-tooltip>
            </button>
          </div>
        </div>
      
        <div style="margin-top: 4px;">
          <hr>
        </div>
        <v-card-actions style="padding: 12px 20px;">
          <button class="add-example-section" @click="isEnter($event, Intent.length - 1)">
            <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
            <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">Add Example</span>
          </button>
        </v-card-actions>
      </v-card>

      <v-row class="mt-2">
        <v-col cols="12" sm="12">
          <div class="intent-panel-body" :class="showActionDialog ? 'intent-panel-open' : 'intent-panel-closed'" @click="showActionDialog = !showActionDialog">
            <div class="intent-left">
              <img :src="showActionDialog ? iconActionOpen : iconActionClose" alt="Action" width="16" height="16" />
              <span :style="{ color: showActionDialog ? '#ffffff' : '#171717' }" class="action-text">Intent Action</span>
            </div>
            <button type="button" class="intent-right">
              <img
                v-if="!showActionDialog"
                src="@/assets/lets-icons_arrow-drop-down.svg"
                alt="expand"
                width="16"
                height="16"
              />
              <img
                v-else
                src="@/assets/lets-icons_arrow-drop-up.svg"
                alt="collapse"
                width="16"
                height="16"
              />
            </button>
          </div>
        </v-col>
      </v-row>

      <!-- Intent Action Card -->
      <v-card class="card-design" v-show="showActionDialog">
        <v-card-title>
          <div class="card-action-title mt-2">
            <img src="@/assets/fluent_sparkle-action-24-filled.svg" alt="img" width="16" height="16" />
            <span style="font-weight: 700; color: #171717; font-size: 14px;">Intent Action</span>
          </div>
        </v-card-title>
        <div style="padding: 0 18px; margin-top: 4px;">
          <hr />
        </div>

        <div
          v-for="(items, indexs) in Request.IntentActions.filter(
            (e) => e.activeFlag == true
          )"
          :key="indexs + 'a'"
          class="action-section"
        >
          <v-row class="mb-2" v-if="!items.isParallelAction && indexs == 0">
            <v-col md="6" sm="12">
              <div style="gap: 2px; margin-bottom: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  Action Type
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Defines what action the system will perform when this intent is matched.</span>
                </v-tooltip>
              </div>

              <v-autocomplete
                class="validation-type-autocomplete"
                :id="'actiontype-intentsessiondetail-' + indexs"
                variant="outlined"
                placeholder="Action Type"
                :items="
                  items.isActionAnswer
                    ? DDActionType
                    : DDActionType.filter(
                        (e) => e.value == 'AT' || e.value == 'CA'
                      )
                "
                item-title="name"
                item-value="value"
                clearable
                v-model="items.actionType"
                @update:model-value="ChangeAction(items)"
                density="comfortable"
                hide-details="auto"
              >
                <template v-slot:item="{ props, item, index }">
                  <v-list-item 
                    v-bind="props"
                    :id="'actiontype-option-' + index" 
                    :value="item.raw.name" 
                  >
                    <template v-slot:title>
                      <span>{{ item.raw.name }}</span>
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-card v-if="items.isParallelAction" class="card-design pa-4 mt-4 mb-4">
            <div class="parallel-action-delete">
              <div class="text-response mb-1">
                <img src="@/assets/material-icon-theme_redux-action.svg" alt="img" width="16" height="16" />
                <span style="font-size: 14px; font-weight: bold; color: #171717;">Parallel Action</span>
              </div>
              <button type="button" @click="DeleteParallelAction(items)">
                <img src="@/assets/Group.svg" alt="info" width="16" height="16">
              </button>
            </div>
            <div class="mt-2">
              <hr>
            </div>
            <v-row class="mb-2">
              <v-col md="6" sm="12">
                <div class="mt-4" style="gap: 2px;">
                  <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                    Action Type
                  </label>
                  <span style="color: red; margin-left: 4px;">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="16"
                        height="16"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>Defines what action the system will perform when this intent is matched.</span>
                  </v-tooltip>
                </div>
                <v-autocomplete
                  class="validation-type-autocomplete"
                  :id="'actiontype-intentsessiondetail-' + indexs"
                  variant="outlined"
                  placeholder="Action Type"
                  :items="
                    items.isActionAnswer
                      ? DDActionType
                      : DDActionType.filter(
                          (e) => e.value == 'AT' || e.value == 'CA'
                        )
                  "
                  item-title="name"
                  item-value="value"
                  clearable
                  v-model="items.actionType"
                  @update:model-value="ChangeAction(items)"
                  density="comfortable"
                  hide-details="auto"
                >
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item 
                      v-bind="props"
                      :id="'actiontype-option-' + index" 
                      :value="item.raw.name" 
                    >
                      <template v-slot:title>
                        <span>{{ item.raw.name }}</span>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- Parallel Action Contact Agent Content (inside card) -->
            <v-expand-transition>
              <div v-show="items.actionType == 'CA'">
                <div class="d-flex align-center" style="gap: 2px;">
                  <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                    Bot Disable Duration (minutes)
                  </label>
                  <span style="color: red; margin-left: 4px;">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="16"
                        height="16"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>Routes the conversation to a live agent and temporarily disables the bot.</span>
                  </v-tooltip>
                </div>
                <div class="time-field-container mb-4">
                  <v-text-field
                    id="botDisableTime-intentsessiondetail"
                    variant="outlined"
                    density="comfortable"
                    v-model="items.botDisableTime"
                    @keypress="isNumberpositive($event)"
                    placeholder="Bot Disable Duration (minutes)"
                    hide-details="auto"
                    class="time-input"
                    type="number"
                    min="0"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            color="grey-darken-1"
                            class="info-icon"
                            v-bind="props"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>
                          Specify the duration for bot deactivation (in
                          minutes) when transferring to an agent. If
                          left blank, the bot will remain active.
                        </span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </div>
                <div class="text-response mb-1">
                  <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">Text Response</span>
                </div>
                <v-textarea
                  id="prompt-contactAgent-intentsessiondetail"
                  class="text-response-textarea"
                  variant="plain"
                  v-model="items.contactAgent"
                  placeholder="Write a prompt for the message sent to the user."
                  hide-details="auto"
                ></v-textarea>
              </div>
            </v-expand-transition>

            <!-- Parallel Action API Trigger Content (inside card) -->
            <v-expand-transition>
              <div v-show="items.actionType == 'AT'">
                <v-row class="mb-4">
                  <v-col cols="2">
                    <div class="d-flex align-center" style="gap: 2px;">
                      <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                        Method
                      </label>
                      <span style="color: red; margin-left: 4px;">*</span>
                    </div>
                    <v-autocomplete
                      :id="'method-intentsessiondetail-' + indexs"
                      class="validation-type-autocomplete"
                      placeholder="Method"
                      ref="model"
                      item-title="name"
                      :items="DDMethod"
                      clearable
                      variant="outlined"
                      v-model="items.method"
                      density="comfortable"
                      hide-details="auto"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="d-flex align-center" style="gap: 2px;">
                      <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                        API Endpoint
                      </label>
                      <span style="color: red; margin-left: 4px;">*</span>
                    </div>
                    <v-text-field
                      :id="'APIendpoint-intentsessiondetail-' + indexs"
                      placeholder="API Endpoint"
                      v-model="items.apiEndpoint"
                      variant="outlined"
                      density="comfortable"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="mb-6">
                  <div class="text-response mb-1">
                    <img src="@/assets/tdesign_api.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">Headers</span>
                  </div>
                  <div class="mb-5 mt-3">
                    <hr>
                  </div>
                  <div
                    v-for="(header, headerIndex) in items.listHeadersAPITrigger"
                    :key="headerIndex + 'header'"
                    class="mb-3"
                  >
                    <v-row>
                      <v-col cols="5">
                        <label for="text" style="color: #171717;">Key</label>
                        <v-text-field
                          :id="'key-intentsessiondetail-' + headerIndex"
                          placeholder="Key"
                          v-model="header.key"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="5">
                        <label for="text" style="color: #171717;">Value</label>
                        <v-text-field
                          :id="'value-intentsessiondetail-' + headerIndex"
                          placeholder="Value"
                          v-model="header.value"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" style="display: flex; justify-content: center;">
                        <div class="action-divider"></div>
                      </v-col>
                      <v-col cols="1" class="d-flex align-center">
                        <v-btn
                          :id="'DeleteHeader-intentsessiondetail-' + headerIndex"
                          @click="DeleteHeader(items, indexs, headerIndex)"
                          icon
                          size="small"
                          variant="text"
                          color="error"
                        >
                          <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <img
                                v-bind="props"
                                src="@/assets/Group.svg"
                                alt="info"
                                width="16"
                                height="16"
                                style="cursor: pointer; margin-left: 4px;"
                              />
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  <v-tooltip location="top" max-width="240px">
                    <template v-slot:activator="{ props }">
                      <button
                        v-bind="props"
                        :id="'AddColumn-intentsessiondetail-' + indexs"
                        @click="AddHeader(items)"
                        class="add-example-section"
                        type="button"
                      >
                        <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                        <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">Add Header</span>
                      </button>
                    </template>
                    <span>Add another header key and value to
                      include extra information in your API request</span>
                  </v-tooltip>
                </div>
                <div class="mb-6">
                  <div class="text-response mb-1">
                    <img src="@/assets/si_json-duotone.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">JSON Request</span>
                  </div>
                  <div class="mb-5 mt-3">
                    <hr>
                  </div>
                  <div class="mt-4 d-flex align-center" style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      JSON Model
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="16"
                          height="16"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>Select the model used to extract JSON data from the user’s message before sending it to the API.</span>
                    </v-tooltip>
                  </div>
                  <v-row class="mb-3">
                    <v-col cols="5">
                      <v-autocomplete
                        :id="'modeljason-intentsessiondetail-' + indexs"
                        class="validation-type-autocomplete mt-2"
                        ref="model"
                        placeholder="JSON Model"
                        :items="listDDModelDisplayName"
                        :item-title="getItemModelNameText"
                        item-value="modelDisplayID"
                        clearable
                        variant="outlined"
                        density="comfortable"
                        v-model="items.modelDisplayRouting"
                        hide-details="auto"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <div class="json-editor-container">
                    <div class="json-variables">
                      <div class="variables-header">
                        <span class="text-subtitle-2" style="color: #171717; font-weight: 400;">Available Variables (Click or drag to insert)</span>
                      </div>
                      <div class="variables-grid">
                        <!-- Variable chips replicated -->
                        <v-tooltip location="top" max-width="310px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-transectionID-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{transactionID}')"
                              @click="insertVariable('{transactionID}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">Transaction ID</span>
                            </v-chip>
                          </template>
                          <span>Use this field to link the current chat session to a specific transaction or record ID.</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="290px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-channel-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{channel}')"
                              @click="insertVariable('{channel}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">Channel</span>
                            </v-chip>
                          </template>
                          <span>The specific application or interface used by the user to send messages to the system.</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="290px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-channelID-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{channelID}')"
                              @click="insertVariable('{channelID}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">Channel ID</span>
                            </v-chip>
                          </template>
                          <span>The unique technical code for the platform where the user is chatting.</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="290px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-userchannel-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{userChannel}')"
                              @click="insertVariable('{userChannel}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">User Channel</span>
                            </v-chip>
                          </template>
                          <span>The specific application or interface used by the user to send messages to the system.</span>
                        </v-tooltip>
                        <v-tooltip location="top" max-width="330px">
                          <template v-slot:activator="{ props }">
                            <v-chip
                              v-bind="props"
                              :id="'JSONValidate-sessionID-intentsessiondetail' + indexs"
                              class="variable-chip"
                              @dragstart="onDragStart($event, '{sessionID}')"
                              @click="insertVariable('{sessionID}', indexs)"
                              draggable="true"
                              color="primary"
                              variant="outlined"
                              size="small"
                            >
                              <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                              <span style="color: #3859D0; margin-left: 6px;">Session ID</span>
                            </v-chip>
                          </template>
                          <span>A unique code assigned to this single conversation instance for logging and maintaining context until the chat ends.</span>
                        </v-tooltip>
                      </div>
                    </div>
                    <prism-editor
                      :id="'codeEditor-' + indexs"
                      class="modern-editor"
                      v-model="items.jsonValidate"
                      :highlight="highlighter"
                      @drop="onDrop($event)"
                      @dragover="onDragOver($event)"
                      @dragleave="onDragLeave($event)"
                      :line-numbers="true"
                      :autoStyleLineNumbers="true"
                      :ignoreTabKey="true"
                    ></prism-editor>
                  </div>
                </div>
                <div class="mb-6">
                  <div class="text-response mb-1">
                    <img src="@/assets/hugeicons_password-validation.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">Validation</span>
                  </div>
                  <div class="mb-5 mt-3">
                    <hr>
                  </div>
                  <div
                    v-for="(valid, indexValid) in items.listValidation"
                    :key="indexValid + 'Validate'"
                    class="mb-4"
                  >
                    <v-row>
                      <v-col cols="12" md="11">
                        <v-card class="validation-item-card" flat>
                          <div class="d-flex justify-space-between align-start flex-wrap" style="gap:16px;">
                            <div class="validation-fields d-flex flex-wrap" style="flex:1; gap:16px;">
                              <div class="validation-field" style="min-width:220px; flex:1;">
                                <label class="validation-label">Key</label>
                                <v-text-field
                                  placeholder="Key"
                                  v-model="valid.key"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                ></v-text-field>
                              </div>
                              <div class="validation-field" style="min-width:240px; flex:1;">
                                <div class="d-flex align-center" style="gap:2px;">
                                  <label class="validation-label">Validation Type</label>
                                  <span style="color:red; margin-left:4px;">*</span>
                                </div>
                                <v-autocomplete
                                  class="validation-type-autocomplete"
                                  ref="model"
                                  placeholder="Validation Type"
                                  :items="DDTypeValidation"
                                  item-title="name"
                                  item-value="value"
                                  clearable
                                  variant="outlined"
                                  v-model="valid.typeValidation"
                                  density="comfortable"
                                  hide-details
                                ></v-autocomplete>
                              </div>
                              <div
                                class="validation-field"
                                v-if="valid.typeValidation == 'MCV'"
                                style="min-width:200px; flex:1;"
                              >
                                <label class="validation-label">Maximum Characters</label>
                                <v-text-field
                                  :id="'NumberOfCharacter-intentsessiondetail' + indexs"
                                  placeholder="Enter maximum characters"
                                  v-model="valid.numberOfCharacter"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                ></v-text-field>
                              </div>
                              <div
                                class="validation-field"
                                v-if="valid.typeValidation == 'RV'"
                                style="min-width:240px; flex:1;"
                              >
                                <label class="validation-label">Regular Expression</label>
                                <v-text-field
                                  :id="'ValidationRegularExpression-intentsessiondetail' + indexs"
                                  placeholder="Regular Expression"
                                  v-model="valid.regExp"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                ></v-text-field>
                              </div>
                            </div>
                          </div>
                          <div class="validation-message mt-4">
                            <v-textarea
                              variant="outlined"
                              v-model="valid.promptMessage"
                              placeholder="Error Message"
                              hide-details="auto"
                            ></v-textarea>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="1">
                        <div class="validation-actions" style="align-self:flex-start;">
                          <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                v-bind="props"
                                :id="'DeleteValidation-intentsessiondetail' + indexs"
                                @click="DeleteValidation(items, indexs, indexValid)"
                                icon
                                size="small"
                                variant="text"
                                color="error"
                              >
                                <img src="@/assets/Group.svg" alt="delete" width="16" height="16" />
                              </v-btn>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  <v-tooltip location="top" max-width="260px">
                    <template v-slot:activator="{ props }">
                      <button
                        v-bind="props"
                        :id="'AddColumn-intentsessiondetail-' + indexs"
                        @click="AddValidation(items)"
                        class="add-example-section"
                        type="button"
                      >
                        <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                        <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">Add Validation</span>
                      </button>
                    </template>
                    <span>Create another validation to set a key , validation type , and error message</span>
                  </v-tooltip>
                </div>
                <div class="mb-4">
                  <div class="text-response mb-1">
                    <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                    <span style="font-size: 14px; font-weight: bold; color: #171717;">Text Response</span>
                  </div>
                  <v-textarea
                    variant="outlined"
                    v-model="items.textResponse"
                    placeholder="Write a prompt for the message sent to the user."
                    hide-details="auto"
                  ></v-textarea>
                </div>
              </div>
            </v-expand-transition>
          </v-card>


          <!-- Vector Type Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'VT'">
              <v-row class="mb-4">
                <v-col cols="6">
                  <div style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      Document Name
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="16"
                          height="16"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>Defines what action the system will perform when this intent is matched.</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    :id="'vectorname-intentsessiondetail-' + indexs"
                    class="validation-type-autocomplete"
                    placeholder="Document Name"
                    :items="DDVector"
                    item-title="name"
                    item-value="name"
                    clearable
                    variant="outlined"
                    v-model="VectorName"
                    @update:model-value="GetByVector()"
                    density="comfortable"
                    hide-details="auto"s
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'vectorname-option-' + index" 
                        :value="item.raw.name" 
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-data-table
                v-show="ShowTable"
                :items-per-page="itemsPerPage"
                :server-items-length="searchTotalTable"
                v-model:options="options"
                :items="dataTable"
                :headers="headers"
                :loading="loadingTable"
                loading-text="Loading..."
                fixed-header
                class="elevation-1 vector-table mb-4"
                density="comfortable"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-center pa-2">
                      <v-checkbox
                        :id="
                          'selectvector-intentsessiondetail-' + indexs
                        "
                        v-model="item.selected"
                        @change="
                          SelectVector(
                            items,
                            item.selected,
                            item.id,
                            item.textORG
                          )
                        "
                        hide-details
                        density="compact"
                        color="#C32E0E"
                      ></v-checkbox>
                    </td>
                    <td class="pa-2">
                      <div class="text-container">
                        <span
                          :class="[
                            item.show
                              ? 'text-content-show'
                              : 'text-content',
                          ]"
                          v-html="formatText(item.textORG)"
                        ></span>
                      </div>
                    </td>
                    <td class="pa-2">
                      <div class="text-container">
                        <span
                          :class="[
                            item.show
                              ? 'text-content-show'
                              : 'text-content',
                          ]"
                          v-html="formatText(item.textEN)"
                        ></span>
                        <v-btn
                          :id="
                            'itemshow-intentsessiondetail-' + indexs
                          "
                          @click="item.show = !item.show"
                          icon
                          size="small"
                          variant="text"
                          class="ml-2"
                        >
                          <v-icon>{{
                            item.show
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          }}</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <div class="selected-vectors mb-4 mt-4 pa-2" v-if="items.vectorDetail && items.vectorDetail.length > 0">
                <div class="mb-2">
                  <span class="text-subtitle-2 font-weight-medium"
                    >Selected Chunks</span
                  >
                </div>
                <div class="d-flex flex-wrap" style="gap: 8px;">
                  <v-chip
                    v-for="(item3, vectorIndex) in items.vectorDetail"
                    :key="vectorIndex + '_TextORG'"
                    closable
                    color="grey"
                    variant="elevated"
                    size="small"
                    class="selected-chunks-design d-flex align-center"
                    @click:close="DeleteVectorByBtn(items, item3.tblVector)"
                  >
                    <span class="chip-text-design">{{ item3.textORG }}</span>
                    <button
                      type="button"
                      class="d-flex align-center ml-2"
                      @click.stop="DeleteVectorByBtn(items, item3.tblVector)"
                    >
                      <img src="@/assets/Frame 1000009610.svg" alt="icon" width="20" height="20" />
                    </button>
                  </v-chip>
                </div>
              </div>


              <v-textarea
                :id="'textarea-prompt-intentsessiondetail-' + indexs"
                class="text-response-textarea"
                variant="plain"
                v-model="items.prompt"
                placeholder="Enter a prompt"
                hide-details="auto"
              ></v-textarea>
            </div>
          </v-expand-transition>

          <!-- Text Response Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'TR'">
              <v-textarea
                :id="'textarea-message-intentsessiondetail-' + indexs"
                class="text-response-textarea"
                variant="plain"
                v-model="items.textResponse"
                placeholder="Write a prompt for the message sent to the user"
                hide-details="auto"
              ></v-textarea>
            </div>
          </v-expand-transition>

          <!-- Model Routing Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'MR'">
              <div class="d-flex align-center" style="gap: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  Model Routing
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Routes this intent to an existing model.</span>
                </v-tooltip>
              </div>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    id="choose-model-modelrouting-intentsessiondetail"
                    class="validation-type-autocomplete"
                    ref="model"
                    placeholder="Model Routing"
                    :items="listDDModelDisplayName"
                    :item-title="getItemModelNameText"
                    item-value="modelDisplayID"
                    clearable
                    variant="outlined"
                    v-model="items.modelDisplayRouting"
                    density="comfortable"
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'nextrouting-option-' + index" 
                        :value="item.raw.name" 
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>

          <!-- Next Routing Content -->
          <v-expand-transition>
            <div v-show="items.actionType == 'NR'">
              <div class="d-flex align-center" style="gap: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  Next Routing
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Routes this intent to another intent group to continue intent matching.</span>
                </v-tooltip>
              </div>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :id="'nextrouting-intentsessiondetail-' + indexs"
                    class="validation-type-autocomplete"
                    ref="model"
                    placeholder="Next Routing"
                    :items="listDDIntentGroup"
                    item-title="name"
                    item-value="id"
                    clearable
                    variant="outlined"
                    v-model="items.nextRouting"
                    density="comfortable"
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'nextrouting-options-' + index" 
                        :value="item.raw.name" 
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>

          <!-- Contact Agent Content (non-parallel only) -->
          <v-expand-transition v-if="!items.isParallelAction">
            <div v-show="items.actionType == 'CA'">
              <div class="d-flex align-center" style="gap: 2px;">
                <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                  Bot Disable Duration (minutes)
                </label>
                <span style="color: red; margin-left: 4px;">*</span>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="16"
                      height="16"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Routes the conversation to a live agent and temporarily disables the bot.</span>
                </v-tooltip>
              </div>
              <!-- Bot Disable Time Field -->
              <div class="time-field-container mb-4">
                <v-text-field
                  id="botDisableTime-intentsessiondetail"
                  variant="outlined"
                  density="comfortable"
                  v-model="items.botDisableTime"
                  @keypress="isNumberpositive($event)"
                  placeholder="Bot Disable Duration (minutes)"
                  hide-details="auto"
                  class="time-input"
                  type="number"
                  min="0"
                >
                  <template v-slot:append-outer>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="small"
                          color="grey-darken-1"
                          class="info-icon"
                          v-bind="props"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >Specify the duration for bot deactivation (in
                        minutes) when transferring to an agent. If
                        left blank, the bot will remain active.</span
                      >
                    </v-tooltip>
                  </template>
                </v-text-field>
              </div>

              <!-- Contact Agent Message -->
              <div class="text-response mb-1">
                <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                <span style="font-size: 14px; font-weight: bold; color: #171717;">Text Response</span>
              </div>
              <v-textarea
                id="prompt-contactAgent-intentsessiondetail"
                class="text-response-textarea"
                variant="plain"
                v-model="items.contactAgent"
                placeholder="Write a prompt for the message sent to the user."
                hide-details="auto"
              ></v-textarea>
            </div>
          </v-expand-transition>

          <!-- API Trigger Content (non-parallel only) -->
          <v-expand-transition v-if="!items.isParallelAction">
            <div v-show="items.actionType == 'AT'">
              <!-- API Method and Endpoint -->
              <v-row class="mb-4">
                <v-col cols="2">
                  <div class="d-flex align-center" style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      Method
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                  </div>
                  <v-autocomplete
                    :id="'method-intentsessiondetail-' + indexs"
                    class="validation-type-autocomplete"
                    placeholder="Method"
                    ref="model"
                    item-title="name"
                    :items="DDMethod"
                    clearable
                    variant="outlined"
                    v-model="items.method"
                    density="comfortable"
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center" style="gap: 2px;">
                    <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                      API Endpoint
                    </label>
                    <span style="color: red; margin-left: 4px;">*</span>
                  </div>
                  <v-text-field
                    :id="'APIendpoint-intentsessiondetail-' + indexs"
                    placeholder="API Endpoint"
                    v-model="items.apiEndpoint"
                    variant="outlined"
                    density="comfortable"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Headers Section -->
              <div class="mb-6">
                <div class="text-response mb-1">
                  <img src="@/assets/tdesign_api.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">Headers</span>
                </div>
                <div class="mb-5 mt-3">
                  <hr>
                </div>
                <div
                  v-for="(
                    header, headerIndex
                  ) in items.listHeadersAPITrigger"
                  :key="headerIndex + 'header'"
                  class="mb-3"
                >
                  <v-row>
                    <v-col cols="5">
                      <label for="text" style="color: #171717;">Key</label>
                      <v-text-field
                        :id="'key-intentsessiondetail-' + headerIndex"
                        placeholder="Key"
                        v-model="header.key"
                        variant="outlined"
                        density="comfortable"
                        hide-details
                        color="primary"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="5">
                      <label for="text" style="color: #171717;">Value</label>
                      <v-text-field
                        :id="
                          'value-intentsessiondetail-' + headerIndex
                        "
                        placeholder="Value"
                        v-model="header.value"
                        variant="outlined"
                        density="comfortable"
                        hide-details
                        color="primary"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1" style="display: flex; justify-content: center;">
                      <div class="action-divider"></div>
                    </v-col>
                    <v-col cols="1" class="d-flex align-center">
                      <v-btn
                        :id="
                          'DeleteHeader-intentsessiondetail-' +
                          headerIndex
                        "
                        @click="
                          DeleteHeader(items, indexs, headerIndex)
                        "
                        icon
                        size="small"
                        variant="text"
                        color="error"
                      >
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <img
                              v-bind="props"
                              src="@/assets/Group.svg"
                              alt="info"
                              width="16"
                              height="16"
                              style="cursor: pointer; margin-left: 4px;"
                            />
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>

                <v-tooltip location="top" max-width="240px">
                  <template v-slot:activator="{ props }">
                    <button
                      v-bind="props"
                      :id="'AddColumn-intentsessiondetail-' + indexs"
                      @click="AddHeader(items)"
                      class="add-example-section"
                      type="button"
                    >
                      <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                      <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">Add Header</span>
                    </button>
                  </template>
                  <span>Add another header key and value to
                    include extra information in your API request</span>
                </v-tooltip>
              </div>

              <!-- JSON Request Section -->
              <div class="mb-6">
                <div class="text-response mb-1">
                  <img src="@/assets/si_json-duotone.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">JSON Request</span>
                </div>
                <div class="mb-5 mt-3">
                  <hr>
                </div>
                <div class="mt-4 d-flex align-center" style="gap: 2px;">
                  <label for="intent-session-name" class="text-sm font-medium text-gray-700">
                    JSON Model
                  </label>
                  <span style="color: red; margin-left: 4px;">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="16"
                        height="16"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>Select the model used to extract JSON data from the user’s message before sending it to the API.</span>
                  </v-tooltip>
                </div>

                <v-row class="mb-3">
                  <v-col cols="5">
                    <v-autocomplete
                      :id="'modeljason-intentsessiondetail-' + indexs"
                      class="validation-type-autocomplete mt-2"
                      ref="model"
                      placeholder="JSON Model"
                      :items="listDDModelDisplayName"
                      :item-title="getItemModelNameText"
                      item-value="modelDisplayID"
                      clearable
                      variant="outlined"
                      density="comfortable"
                      v-model="items.modelDisplayRouting"
                      hide-details="auto"
                      color="primary"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <div class="json-editor-container">
                  <div class="json-variables">
                    <div class="variables-header">
                      <span class="text-subtitle-2" style="color: #171717; font-weight: 400;">Available Variables (Click or drag to insert)</span>
                    </div>
                    <div class="variables-grid">
                      <v-tooltip location="top" max-width="310px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-transectionID-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{transactionID}')
                            "
                            @click="
                              insertVariable('{transactionID}', indexs)
                            "
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">Transaction ID</span>
                          </v-chip>
                        </template>
                        <span>Use this field to link the current chat session to a specific transaction or record ID.</span>
                      </v-tooltip>
                      
                      <v-tooltip location="top" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-channel-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="onDragStart($event, '{channel}')"
                            @click="insertVariable('{channel}', indexs)"
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">Channel</span>
                          </v-chip>
                        </template>
                        <span>The specific application or interface used by the user to send messages to the system.</span>
                      </v-tooltip>

                      <v-tooltip location="top" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-channelID-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{channelID}')
                            "
                            @click="insertVariable('{channelID}', indexs)"
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">Channel ID</span>
                          </v-chip>
                        </template>
                        <span>The unique technical code for the platform where the user is chatting.</span>
                      </v-tooltip>

                      <v-tooltip location="top" max-width="290px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-userchannel-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{userChannel}')
                            "
                            @click="
                              insertVariable('{userChannel}', indexs)
                            "
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/fluent_channel-share-24-filled.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">User Channel</span>
                          </v-chip>
                        </template>
                        <span>The specific application or interface used by the user to send messages to the system.</span>
                      </v-tooltip>

                      <v-tooltip location="top" max-width="330px">
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :id="
                              'JSONValidate-sessionID-intentsessiondetail' +
                              indexs
                            "
                            class="variable-chip"
                            @dragstart="
                              onDragStart($event, '{sessionID}')
                            "
                            @click="insertVariable('{sessionID}', indexs)"
                            draggable="true"
                            color="primary"
                            variant="outlined"
                            size="small"
                          >
                            <img src="@/assets/proicons_hash.svg" alt="img" width="14" height="14" />
                            <span style="color: #3859D0; margin-left: 6px;">Session ID</span>
                          </v-chip>
                        </template>
                        <span>A unique code assigned to this single conversation instance for logging and maintaining context until the chat ends.</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <prism-editor
                    :id="'codeEditor-' + indexs"
                    class="modern-editor"
                    v-model="items.jsonValidate"
                    :highlight="highlighter"
                    @drop="onDrop($event)"
                    @dragover="onDragOver($event)"
                    @dragleave="onDragLeave($event)"
                    :line-numbers="true"
                    :autoStyleLineNumbers="true"
                    :ignoreTabKey="true"
                  ></prism-editor>
                </div>
              </div>

              <!-- Validation Section -->
              <div class="mb-6">
                <div class="text-response mb-1">
                  <img src="@/assets/hugeicons_password-validation.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">Validation</span>
                </div>
                <div class="mb-5 mt-3">
                  <hr>
                </div>

                <div
                  v-for="(valid, indexValid) in items.listValidation"
                  :key="indexValid + 'Validate'"
                  class="mb-4"
                >
                  <v-row>
                    <v-col cols="12" md="11">
                      <v-card class="validation-item-card" flat>
                        <div class="d-flex justify-space-between align-start flex-wrap" style="gap:16px;">
                          <div class="validation-fields d-flex flex-wrap" style="flex:1; gap:16px;">
                            <div class="validation-field" style="min-width:220px; flex:1;">
                              <label class="validation-label">Key</label>
                              <v-text-field
                                placeholder="Key"
                                v-model="valid.key"
                                variant="outlined"
                                density="comfortable"
                                hide-details
                              ></v-text-field>
                            </div>
                            <div class="validation-field" style="min-width:240px; flex:1;">
                              <div class="d-flex align-center" style="gap:2px;">
                                <label class="validation-label">Validation Type</label>
                                <span style="color:red; margin-left:4px;">*</span>
                              </div>
                              <v-autocomplete
                                class="validation-type-autocomplete"
                                ref="model"
                                placeholder="Validation Type"
                                :items="DDTypeValidation"
                                item-title="name"
                                item-value="value"
                                clearable
                                variant="outlined"
                                v-model="valid.typeValidation"
                                density="comfortable"
                                hide-details
                              ></v-autocomplete>
                            </div>
                            <div
                              class="validation-field"
                              v-if="valid.typeValidation == 'MCV'"
                              style="min-width:200px; flex:1;"
                            >
                              <label class="validation-label">Maximum Characters</label>
                              <v-text-field
                                :id="'NumberOfCharacter-intentsessiondetail' + indexs"
                                placeholder="Enter maximum characters"
                                v-model="valid.numberOfCharacter"
                                variant="outlined"
                                density="comfortable"
                                hide-details
                              ></v-text-field>
                            </div>
    
                            <div
                              class="validation-field"
                              v-if="valid.typeValidation == 'RV'"
                              style="min-width:240px; flex:1;"
                            >
                              <label class="validation-label">Regular Expression</label>
                              <v-text-field
                                :id="'ValidationRegularExpression-intentsessiondetail' + indexs"
                                placeholder="Regular Expression"
                                v-model="valid.regExp"
                                variant="outlined"
                                density="comfortable"
                                hide-details
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
    
                        <div class="validation-message mt-4">
                          <v-textarea
                            variant="outlined"
                            v-model="valid.promptMessage"
                            placeholder="Error Message"
                            hide-details="auto"
                          ></v-textarea>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="1">
                      <div class="validation-actions" style="align-self:flex-start;">
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              v-bind="props"
                                :id="'DeleteValidation-intentsessiondetail' + indexs"
                                @click="DeleteValidation(items, indexs, indexValid)"
                                icon
                                size="small"
                                variant="text"
                                color="error"
                            >
                              <img src="@/assets/Group.svg" alt="delete" width="16" height="16" />
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <v-tooltip location="top" max-width="260px">
                  <template v-slot:activator="{ props }">
                    <button
                      v-bind="props"
                      :id="'AddColumn-intentsessiondetail-' + indexs"
                      @click="AddValidation(items)"
                      class="add-example-section"
                      type="button"
                    >
                      <img src="@/assets/plus.svg" alt="img" width="10" height="10" />
                      <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">Add Validation</span>
                    </button>
                  </template>
                  <span>Create another validation to set a key , validation type , and error message</span>
                </v-tooltip>

                <!-- <v-btn
                  :id="'AddValidation-intentsessiondetail' + indexs"
                  @click="AddValidation(items)"
                  variant="outlined"
                  color="primary"
                  size="small"
                  class="mt-2"
                >
                  <v-icon start>mdi-plus-circle</v-icon>
                  Add Validation
                </v-btn> -->
              </div>

              <!-- Text Response Section for API -->
              <div class="mb-4">
                <div class="text-response mb-1">
                  <img src="@/assets/fluent_chat-20-regular.svg" alt="img" width="16" height="16" />
                  <span style="font-size: 14px; font-weight: bold; color: #171717;">Text Response</span>
                </div>
                <v-textarea
                  variant="outlined"
                  v-model="items.textResponse"
                  placeholder="Write a prompt for the message sent to the user."
                  hide-details="auto"
                ></v-textarea>
              </div>
            </div>
          </v-expand-transition>
        </div>
        
        <div class="intent-action-btn-wrapper">
          <v-tooltip location="top" max-width="260px">
            <template v-slot:activator="{ props }">
              <button
                type="button"
                v-bind="props"
                :id="'AddNewAction-intentsessiondetail'"
                @click="AddNewAction()"
                variant="outlined"
                size="large"
                block
                class="intent-action-btn"
              >
                <img src="@/assets/ic_round-plus.svg" alt="img" width="16" height="16" />
                <span class="intent-text">Add Parallel Action</span>
              </button>
            </template>
            <span style="font-size: 14px;">Add another action for the intent session.</span>
          </v-tooltip>
        </div>
      </v-card>
      
      <div class="mt-6">
        <hr>
      </div>
      
      <v-row class="mt-2 gap-6">
        <v-col cols="12" class="d-flex justify-end">
          <div style="display: flex; gap: 12px;">
            <button class="add-example-section"
              :id="'button-close-intentsessiondetail'"
              @click="Back()" >
              <img src="@/assets/line-md_close.svg" alt="img" width="12" height="12" />
              <span style="font-weight: 400; font-size: 12px; color: #C32E0E;">Close</span>
            </button>
          <!-- <v-btn
            :id="'button-close-intentsessiondetail'"
            @click="Back()"
            variant="outlined"
            color="warning"
            size="large"
            class="mr-4"
          >
            <v-icon start>mdi-close</v-icon>
            CLOSE
          </v-btn> -->
          
            <button
              class="btn-action-design"
              v-if="AddEvent"
              :id="'button-saveadd-intentsessiondetail'"
              @click="SaveAdd()"
              >
              <img src="@/assets/mage_save-btn.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">Save</span>
            </button>
            <button
              class="btn-action-design"
              v-else
              :id="'button-saveedit-intentsessiondetail'"
                @click="SaveEdit()"
            >
              <img src="@/assets/mage_save-floppy.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">Save</span>
            </button>
          </div>
        </v-col>
      </v-row>

      <!-- <v-card class="card2 mt-4">
        <v-container class="px-6 py-6">
          <v-row>
            <v-col cols="12" sm="12" md="5">
              <v-text-field
                id="intentsessionname-intentsessiondetail"
                variant="outlined"
                density="comfortable"
                label="Intent Session Name*"
                v-model="Request.Name"
                :rules="[rules.required]"
                hide-details="auto"
                color="primary"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-text-field
                id="score-intentsessiondetail"
                variant="outlined"
                density="comfortable"
                label="Score"
                v-model="Request.Score"
                @keypress="isNumberpositive($event)"
                hide-details="auto"
                color="primary"
              >
                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" size="small" color="grey-darken-1">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoScore") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <v-checkbox
                id="usememory-intentsessiondetail"
                v-model="Request.UseMemory"
                label="Use memory"
                color="primary"
                hide-details
                density="comfortable"
              >
                <template v-slot:label>
                  <v-tooltip location="top" max-width="40vw">
                    <template v-slot:activator="{ props }">
                      <label v-bind="props" class="text-body-2"
                        >Use memory</label
                      >
                    </template>
                    <span>User</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="mt-4">
              <v-textarea
                id="prompt-intentsessiondetail"
                variant="outlined"
                rows="7"
                v-model="Request.PromptSession"
                label="Prompt Session"
                placeholder="Enter the Prompt..."
                hide-details="auto"
                color="primary"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-expansion-panels
            v-model="panel"
            multiple
            class="mt-6"
            variant="accordion"
          >
            <v-expansion-panel class="modern-panel">
              <v-expansion-panel-title
                id="intent-intentsessiondetail"
                class="panel-header"
              >
                <template v-slot:default="{ expanded }">
                  <v-row no-gutters>
                    <v-col cols="4" class="d-flex justify-start">
                      <v-icon
                        :class="expanded ? 'rotate-180' : ''"
                        class="transition-transform"
                      >
                        mdi-chevron-down
                      </v-icon>
                      <span class="header-text ml-2">Intent</span>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-title>

              <v-expansion-panel-text class="panel-content">
                <v-row class="mb-4">
                  <v-col cols="12" class="d-flex justify-end align-center">
                    <v-btn
                      id="download-template-intentsessiondetail"
                      variant="text"
                      color="primary"
                      @click="downloadTemplate()"
                      class="mr-4"
                    >
                      <v-icon start>mdi-download</v-icon>
                      Template
                    </v-btn>
                    <DragDropFile
                      id="uploadfile-intentsessiondetail"
                      :dialog="true"
                      :DragDrop="false"
                      :ShowListFile="false"
                      accept=".xlsx"
                      @filesUploaded="processUpload($event)"
                      :allowType="[
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      ]"
                      class="UploadFile"
                    />
                  </v-col>
                </v-row>

                <v-card variant="outlined" class="intent-container">
                  <div
                    v-for="(item, index) in Intent"
                    :key="index"
                    class="intent-item"
                  >
                    <div class="intent-number">{{ index + 1 }}</div>
                    <v-textarea
                      :id="'textarea-intent-intentsessiondetail-' + index"
                      variant="plain"
                      class="intent-textarea"
                      v-model="item.text"
                      placeholder="Enter the message intent..."
                      @keypress="isEnter($event, index)"
                      @keypress.enter="newLineEnter(index)"
                      ref="textareas"
                      @paste="onPaste(index, $event)"
                      @keyup.delete="CheckDeleteIntent(index, item.text)"
                      rows="2"
                      auto-grow
                      hide-details
                    ></v-textarea>
                    <v-btn
                      :id="'button-delete-intentsessiondetail-' + index"
                      v-show="index + 1 < Intent.length"
                      @click="Intent.splice(index, 1)"
                      icon
                      size="small"
                      variant="text"
                      color="error"
                      class="delete-intent-btn"
                    >
                      <v-tooltip location="top" open-delay="500">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props">mdi-delete</v-icon>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </v-btn>
                  </div>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel class="modern-panel">
              <v-expansion-panel-title
                id="action-intentsessiondetail"
                class="panel-header"
              >
                <template v-slot:default="{ expanded }">
                  <v-row no-gutters>
                    <v-col cols="4" class="d-flex justify-start">
                      <v-icon
                        :class="expanded ? 'rotate-180' : ''"
                        class="transition-transform"
                      >
                        mdi-chevron-down
                      </v-icon>
                      <span class="header-text ml-2">Action</span>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-title>

              <v-expansion-panel-text class="panel-content">
                <div class="action-container">
                  <div
                    v-for="(items, indexs) in Request.IntentActions.filter(
                      (e) => e.activeFlag == true
                    )"
                    :key="indexs + 'a'"
                    class="action-section mb-8"
                  >

                    <v-divider class="mb-6"></v-divider>

                    <v-row class="mb-4">
                      <v-col md="9" sm="12">
                        <v-autocomplete
                          :id="'actiontype-intentsessiondetail-' + indexs"
                          variant="outlined"
                          density="comfortable"
                          label="Action type*"
                          :items="
                            items.isActionAnswer
                              ? DDActionType
                              : DDActionType.filter(
                                  (e) => e.value == 'AT' || e.value == 'CA'
                                )
                          "
                          item-title="name"
                          item-value="value"
                          clearable
                          v-model="items.actionType"
                          @update:model-value="ChangeAction(items)"
                          hide-details="auto"
                          color="primary"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'actiontype-option-' + index" 
                              :value="item.raw.name" 
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-inner>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  size="small"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Action type information</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        md="3"
                        sm="12"
                        v-if="
                          items.actionType != 'MR' &&
                          items.actionType != 'NR' &&
                          items.actionType != ''
                        "
                      >
                        <v-checkbox
                          :id="'mergeprompt-intentsessiondetail-' + indexs"
                          v-model="items.isMergePrompt"
                          label="Merge prompt"
                          color="primary"
                          hide-details
                          density="comfortable"
                        >
                          <template v-slot:label>
                            <v-tooltip location="top" max-width="40vw">
                              <template v-slot:activator="{ props }">
                                <label v-bind="props" class="text-body-2"
                                  >Merge prompt</label
                                >
                              </template>
                              <span>Merge prompt</span>
                            </v-tooltip>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>

                    <v-expand-transition>
                      <div v-show="items.actionType == 'VT'">
                        <v-row class="mb-4">
                          <v-col cols="6">
                            <v-autocomplete
                              :id="'vectorname-intentsessiondetail-' + indexs"
                              label="Vector Name*"
                              :items="DDVector"
                              item-title="name"
                              item-value="name"
                              clearable
                              variant="outlined"
                              v-model="VectorName"
                              @update:model-value="GetByVector()"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            >
                              <template v-slot:item="{ props, item, index }">
                                <v-list-item 
                                  v-bind="props"
                                  :id="'vectorname-option-' + index" 
                                  :value="item.raw.name" 
                                >
                                  <template v-slot:title>
                                    <span>{{ item.raw.name }}</span>
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-slot:append-inner>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon
                                      v-bind="props"
                                      size="small"
                                      color="grey-darken-1"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("_InfoProvider") }}</span>
                                </v-tooltip>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-data-table
                          v-show="ShowTable"
                          :items-per-page="itemsPerPage"
                          :server-items-length="searchTotalTable"
                          v-model:options="options"
                          :items="dataTable"
                          :headers="headers"
                          :loading="loadingTable"
                          loading-text="Loading..."
                          fixed-header
                          class="elevation-1 vector-table mb-4"
                          density="comfortable"
                        >
                          <template v-slot:item="{ item }">
                            <tr>
                              <td class="text-center pa-2">
                                <v-checkbox
                                  :id="
                                    'selectvector-intentsessiondetail-' + indexs
                                  "
                                  v-model="item.selected"
                                  @change="
                                    SelectVector(
                                      items,
                                      item.selected,
                                      item.id,
                                      item.textORG
                                    )
                                  "
                                  hide-details
                                  density="compact"
                                  color="primary"
                                ></v-checkbox>
                              </td>
                              <td class="pa-2">
                                <div class="text-container">
                                  <span
                                    :class="[
                                      item.show
                                        ? 'text-content-show'
                                        : 'text-content',
                                    ]"
                                    v-html="formatText(item.textORG)"
                                  ></span>
                                </div>
                              </td>
                              <td class="pa-2">
                                <div class="text-container">
                                  <span
                                    :class="[
                                      item.show
                                        ? 'text-content-show'
                                        : 'text-content',
                                    ]"
                                    v-html="formatText(item.textEN)"
                                  ></span>
                                  <v-btn
                                    :id="
                                      'itemshow-intentsessiondetail-' + indexs
                                    "
                                    @click="item.show = !item.show"
                                    icon
                                    size="small"
                                    variant="text"
                                    class="ml-2"
                                  >
                                    <v-icon>{{
                                      item.show
                                        ? "mdi-chevron-up"
                                        : "mdi-chevron-down"
                                    }}</v-icon>
                                  </v-btn>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>

                        <div
                          class="selected-vectors mb-4"
                          v-if="
                            items.vectorDetail && items.vectorDetail.length > 0
                          "
                        >
                          <div class="mb-2">
                            <span class="text-subtitle-2 font-weight-medium"
                              >Selected Vectors:</span
                            >
                          </div>
                          <div class="d-flex flex-wrap ga-2">
                            <v-chip
                              v-for="(item3, vectorIndex) in items.vectorDetail"
                              :key="vectorIndex + '_TextORG'"
                              closable
                              @click:close="
                                DeleteVectorByBtn(items, item3.tblVector)
                              "
                              color="primary"
                              variant="elevated"
                              size="small"
                              class="selected-vector-chip"
                            >
                              <v-tooltip location="top" open-delay="500">
                                <template v-slot:activator="{ props }">
                                  <span v-bind="props">{{
                                    item3.textORG
                                  }}</span>
                                </template>
                                <span>{{ item3.textORG }}</span>
                              </v-tooltip>
                            </v-chip>
                          </div>
                        </div>

                        <v-textarea
                          :id="'textarea-prompt-intentsessiondetail-' + indexs"
                          variant="outlined"
                          v-model="items.prompt"
                          label="Prompt"
                          placeholder="Enter the Prompt..."
                          hide-details="auto"
                          color="primary"
                        ></v-textarea>
                      </div>
                    </v-expand-transition>

                    <v-expand-transition>
                      <div v-show="items.actionType == 'TR'">
                        <v-textarea
                          :id="'textarea-message-intentsessiondetail-' + indexs"
                          variant="outlined"
                          v-model="items.textResponse"
                          label="Message"
                          placeholder="Enter the message..."
                          hide-details="auto"
                          color="primary"
                        ></v-textarea>
                      </div>
                    </v-expand-transition>

                    <v-expand-transition>
                      <div v-show="items.actionType == 'MR'">
                        <v-row>
                          <v-col cols="6">
                            <v-autocomplete
                              id="choose-model-modelrouting-intentsessiondetail"
                              ref="model"
                              label="Next Routing*"
                              :items="listDDModelDisplayName"
                              :item-title="getItemModelNameText"
                              item-value="modelDisplayID"
                              clearable
                              variant="outlined"
                              v-model="items.modelDisplayRouting"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            >
                              <template v-slot:item="{ props, item, index }">
                                <v-list-item 
                                  v-bind="props"
                                  :id="'nextrouting-option-' + index" 
                                  :value="item.raw.name" 
                                >
                                  <template v-slot:title>
                                    <span>{{ item.raw.name }}</span>
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-slot:append-inner>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon
                                      v-bind="props"
                                      size="small"
                                      color="grey-darken-1"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("_InfoProvider") }}</span>
                                </v-tooltip>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>
                    </v-expand-transition>

                    <v-expand-transition>
                      <div v-show="items.actionType == 'NR'">
                        <v-row>
                          <v-col cols="6">
                            <v-autocomplete
                              :id="'nextrouting-intentsessiondetail-' + indexs"
                              ref="model"
                              label="Next Routing*"
                              :items="listDDIntentGroup"
                              item-title="name"
                              item-value="id"
                              clearable
                              variant="outlined"
                              v-model="items.nextRouting"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            >
                              <template v-slot:item="{ props, item, index }">
                                <v-list-item 
                                  v-bind="props"
                                  :id="'nextrouting-options-' + index" 
                                  :value="item.raw.name" 
                                >
                                  <template v-slot:title>
                                    <span>{{ item.raw.name }}</span>
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-slot:append-inner>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-icon
                                      v-bind="props"
                                      size="small"
                                      color="grey-darken-1"
                                    >
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ $t("_InfoProvider") }}</span>
                                </v-tooltip>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>
                    </v-expand-transition>

                    <v-expand-transition>
                      <div v-show="items.actionType == 'CA'">
                        <div class="time-field-container mb-4">
                          <v-text-field
                            id="botDisableTime-intentsessiondetail"
                            variant="outlined"
                            density="comfortable"
                            label="Bot Disable Time (minutes)"
                            v-model="items.botDisableTime"
                            @keypress="isNumberpositive($event)"
                            placeholder="Enter time in minutes"
                            hide-details="auto"
                            class="time-input"
                            type="number"
                            min="0"
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top" max-width="300px">
                                <template v-slot:activator="{ props }">
                                  <v-icon
                                    size="small"
                                    color="grey-darken-1"
                                    class="info-icon"
                                    v-bind="props"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span
                                  >Specify the duration for bot deactivation (in
                                  minutes) when transferring to an agent. If
                                  left blank, the bot will remain active.</span
                                >
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </div>

                        <v-textarea
                          id="prompt-contactAgent-intentsessiondetail"
                          variant="outlined"
                          v-model="items.contactAgent"
                          label="Contact Agent Message"
                          placeholder="Enter the message..."
                          hide-details="auto"
                          color="primary"
                        ></v-textarea>
                      </div>
                    </v-expand-transition>

                    <v-expand-transition>
                      <div v-show="items.actionType == 'AT'">
                        <v-row class="mb-4">
                          <v-col cols="2">
                            <v-autocomplete
                              :id="'method-intentsessiondetail-' + indexs"
                              ref="model"
                              label="Method*"
                              :items="DDMethod"
                              clearable
                              variant="outlined"
                              v-model="items.method"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            />
                          </v-col>
                          <v-col cols="10">
                            <v-text-field
                              :id="'APIendpoint-intentsessiondetail-' + indexs"
                              label="API Endpoint*"
                              v-model="items.apiEndpoint"
                              variant="outlined"
                              density="comfortable"
                              hide-details="auto"
                              color="primary"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <div class="mb-6">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-web</v-icon
                            >
                            <span class="text-h6">Headers</span>
                          </div>

                          <div
                            v-for="(
                              header, headerIndex
                            ) in items.listHeadersAPITrigger"
                            :key="headerIndex + 'header'"
                            class="mb-3"
                          >
                            <v-row>
                              <v-col cols="4">
                                <v-text-field
                                  :id="'key-intentsessiondetail-' + headerIndex"
                                  label="Key"
                                  v-model="header.key"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="7">
                                <v-text-field
                                  :id="
                                    'value-intentsessiondetail-' + headerIndex
                                  "
                                  label="Value"
                                  v-model="header.value"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="1" class="d-flex align-center">
                                <v-btn
                                  :id="
                                    'DeleteHeader-intentsessiondetail-' +
                                    headerIndex
                                  "
                                  @click="
                                    DeleteHeader(items, indexs, headerIndex)
                                  "
                                  icon
                                  size="small"
                                  variant="text"
                                  color="error"
                                >
                                  <v-icon>mdi-delete-circle</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>

                          <v-btn
                            :id="'AddColumn-intentsessiondetail-' + indexs"
                            @click="AddHeader(items)"
                            variant="outlined"
                            color="primary"
                            size="small"
                            class="mt-2"
                          >
                            <v-icon start>mdi-plus-circle</v-icon>
                            Add Header
                          </v-btn>
                        </div>

                        <div class="mb-6">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-code-json</v-icon
                            >
                            <span class="text-h6">JSON Request</span>
                          </div>

                          <v-row class="mb-3">
                            <v-col cols="6">
                              <v-autocomplete
                                :id="'modeljason-intentsessiondetail-' + indexs"
                                ref="model"
                                label="Model JSON*"
                                :items="listDDModelDisplayName"
                                :item-title="getItemModelNameText"
                                item-value="modelDisplayID"
                                clearable
                                variant="outlined"
                                density="comfortable"
                                v-model="items.modelDisplayRouting"
                                hide-details="auto"
                                color="primary"
                              >
                                <template v-slot:append-inner>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon
                                        v-bind="props"
                                        size="small"
                                        color="grey-darken-1"
                                      >
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>{{ $t("_InfoProvider") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>

                          <div class="json-editor-container">
                            <div class="json-variables">
                              <div class="variables-header">
                                <span class="text-subtitle-2"
                                  >Available Variables (Click or drag to
                                  insert)</span
                                >
                              </div>
                              <div class="variables-grid">
                                <v-chip
                                  :id="
                                    'JSONValidate-transectionID-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{transactionID}')
                                  "
                                  @click="
                                    insertVariable('{transactionID}', indexs)
                                  "
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Transaction ID
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-channel-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="onDragStart($event, '{channel}')"
                                  @click="insertVariable('{channel}', indexs)"
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Channel
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-channelID-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{channelID}')
                                  "
                                  @click="insertVariable('{channelID}', indexs)"
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Channel ID
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-userchannel-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{userChannel}')
                                  "
                                  @click="
                                    insertVariable('{userChannel}', indexs)
                                  "
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  User Channel
                                </v-chip>
                                <v-chip
                                  :id="
                                    'JSONValidate-sessionID-intentsessiondetail' +
                                    indexs
                                  "
                                  class="variable-chip"
                                  @dragstart="
                                    onDragStart($event, '{sessionID}')
                                  "
                                  @click="insertVariable('{sessionID}', indexs)"
                                  draggable="true"
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                >
                                  <v-icon start size="small">mdi-drag</v-icon>
                                  Session ID
                                </v-chip>
                              </div>
                            </div>
                            <prism-editor
                              :id="'codeEditor-' + indexs"
                              class="modern-editor"
                              v-model="items.jsonValidate"
                              :highlight="highlighter"
                              @drop="onDrop($event)"
                              @dragover="onDragOver($event)"
                              @dragleave="onDragLeave($event)"
                              :line-numbers="true"
                              :autoStyleLineNumbers="true"
                              :ignoreTabKey="true"
                            ></prism-editor>
                          </div>
                        </div>

                        <div class="mb-6">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-check-circle</v-icon
                            >
                            <span class="text-h6">Validation</span>
                          </div>

                          <div
                            v-for="(valid, indexValid) in items.listValidation"
                            :key="indexValid + 'Validate'"
                            class="mb-4"
                          >
                            <v-row>
                              <v-col sm="12" md="4">
                                <v-text-field
                                  label="Key"
                                  v-model="valid.key"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col sm="12" md="3">
                                <v-autocomplete
                                  ref="model"
                                  label="Type Validate*"
                                  :items="DDTypeValidation"
                                  item-title="name"
                                  item-value="value"
                                  clearable
                                  variant="outlined"
                                  v-model="valid.typeValidation"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                sm="12"
                                md="3"
                                v-if="valid.typeValidation == 'MCV'"
                              >
                                <v-text-field
                                  :id="
                                    'NumberOfCharacter-intentsessiondetail' +
                                    indexs
                                  "
                                  label="Number of Character"
                                  v-model="valid.numberOfCharacter"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                sm="12"
                                md="3"
                                v-if="valid.typeValidation == 'RV'"
                              >
                                <v-text-field
                                  :id="
                                    'ValidationRegularExpression-intentsessiondetail' +
                                    indexs
                                  "
                                  label="Regular Expression"
                                  v-model="valid.regExp"
                                  variant="outlined"
                                  density="comfortable"
                                  hide-details
                                  color="primary"
                                ></v-text-field>
                              </v-col>
                              <v-col sm="12" md="1" class="d-flex align-center">
                                <v-btn
                                  :id="
                                    'DeleteValidation-intentsessiondetail' +
                                    indexs
                                  "
                                  @click="
                                    DeleteValidation(items, indexs, indexValid)
                                  "
                                  icon
                                  size="small"
                                  variant="text"
                                  color="error"
                                >
                                  <v-icon>mdi-delete-circle</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col cols="12">
                                <v-textarea
                                  variant="outlined"
                                  v-model="valid.promptMessage"
                                  label="Error Message"
                                  placeholder="Enter the validation error message..."
                                  hide-details="auto"
                                  color="primary"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </div>

                          <v-btn
                            :id="'AddValidation-intentsessiondetail' + indexs"
                            @click="AddValidation(items)"
                            variant="outlined"
                            color="primary"
                            size="small"
                            class="mt-2"
                          >
                            <v-icon start>mdi-plus-circle</v-icon>
                            Add Validation
                          </v-btn>
                        </div>

                        <div class="mb-4">
                          <div class="section-title-simple mb-3">
                            <v-icon color="primary" class="mr-2"
                              >mdi-message-text</v-icon
                            >
                            <span class="text-h6">Text Response</span>
                          </div>
                          <v-textarea
                            variant="outlined"
                            v-model="items.textResponse"
                            label="Response Message"
                            placeholder="Enter the response message..."
                            hide-details="auto"
                            color="primary"
                          ></v-textarea>
                        </div>
                      </div>
                    </v-expand-transition>
                  </div>

                  <v-btn
                    :id="'AddNewAction-intentsessiondetail'"
                    @click="AddNewAction()"
                    variant="outlined"
                    color="primary"
                    size="large"
                    block
                    class="add-action-btn"
                  >
                    <v-icon start>mdi-plus-circle</v-icon>
                    Add New Action
                  </v-btn>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          Action Buttons
          <v-row class="mt-8">
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                :id="'button-close-intentsessiondetail'"
                @click="Back()"
                variant="outlined"
                color="warning"
                size="large"
                class="mr-4"
              >
                <v-icon start>mdi-close</v-icon>
                CLOSE
              </v-btn>
              <v-btn
                  v-if="AddEvent"
                  :id="'button-saveadd-intentsessiondetail'"
                  @click="SaveAdd()"
                variant="elevated"
                color="primary"
                size="large"
              >
                <v-icon start>mdi-content-save</v-icon>
                SAVE
              </v-btn>
              <v-btn
                  v-else
                  :id="'button-saveedit-intentsessiondetail'"
                    @click="SaveEdit()"
                variant="elevated"
                color="primary"
                size="large"
              >
                <v-icon start>mdi-content-save</v-icon>
                SAVE
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card> -->
    </v-container>

    <!-- Loading Dialog -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Clipboard Popup -->
    <v-snackbar
      v-model="showClipboardPopup"
      timeout="2000"
      color="success"
      location="bottom left"
    >
      <v-icon start>mdi-check</v-icon>
      Copied to clipboard!
    </v-snackbar>

    <!-- Name Required Dialog -->
    <v-dialog v-model="showNameRequiredDialog" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">Intent Session Name is Required</h3>
          <button type="button" @click="showNameRequiredDialog = false" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">Please fill in all required information.</p>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <v-btn class="ok-required-btn" @click="showNameRequiredDialog = false" :id="'button-requiredname-ok'">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Confirm Upload -->
    <v-dialog v-model="showConfirmDialog" max-width="570">
      <v-card class="confirm-dialog-card">
        <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
          <span class="dialog-title font-weight-bold">Import Example Question Text</span>
          <v-btn icon variant="text" density="comfortable" @click="showConfirmDialog = false">
            <img src="@/assets/Vector.svg" alt="icon" width="10" height="10">
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6 pb-4 px-4 body-text">
          Do you want to Import an Example Question Text ?
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
          <button type="button" class="cancel-btn" @click="showConfirmDialog = false" :disabled="deleting">Cancel</button>
          <button type="button" class="confirm-btn" @click="ConfirmProcess">
            <span style="color: #ffffff; font-size: 13px; letter-spacing: 1px;">Confirm</span>
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles
import { highlight, languages } from "prismjs";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-rust";
import DragDropFile from "@/components/DragDropFile.vue";
import iconGoalsColor from '@/assets/mage_goals-fill.svg';
import iconGoalsWhite from '@/assets/mage_goals-fill-white.svg';
import iconActionOpen from '@/assets/material-symbols_action-key-white.svg';
import iconActionClose from '@/assets/material-symbols_action-key.svg';
import expandTop from '@/assets/expand-top.svg';
import expandDown from '@/assets/Expand.svg';
import ExcelJS from "exceljs";

import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
export default {
  name: "IntentSessionDetail",
  inject: ["flagNav"],
  components: { PrismEditor, DragDropFile },
  mixins: [checkPermissionTwo],
  data: () => ({
    showConfirmDialog: false,
    showSuccess: false,
    successMessage: '',
    _toastTimer: null,
    showDialog: false,
    showActionDialog: false,
    showNameRequiredDialog: false,
    options: {},
    dataTable: [],
    VectorDetail: [],
    Selected: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    listDDModelDisplayName: [],
    listDDIntentGroup: [],
    Search: "",
    CodeEx: '{\n   "A":""\n}',
    id: null,
    panel: [0, 1],
    dialog: false,
    loadingTable: false,
    AddEvent: false,
    ShowTable: false,
    today: null,
    loading: true,
    DataCol: [],
    type: null,
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    showClipboardPopup: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    Intent: [{ text: "What was that?" }, { text: "" }],
    VectorName: "",
    Vectors: "",
    Request: {
      IntentGroupID: 0,
      IntentSessionID: 0,
      IntentActionID: 0,
      Score: "",
      Name: "",
      UseMemory: false,
      PromptSession:
        "Find the Intent from the message of users.\n#Condition for Response\n1. If the user asks a question related to or similar in meaning to the #Group Intent below. You must response 1. Otherwise, 0\n#Group Intent\n",
      ActionType: "",
      TBLVector: "",
      Intent: "",
      Prompt: "",
      IntentActions: [],
    },
    RequestIntentAction: {
      intentActionID: 0,
      tblVector: "",
      prompt: "",
      textResponse: "",
      method: "",
      apiEndpoint: "",
      listHeadersAPITrigger: [
        {
          key: "",
          value: "",
        },
      ],
      jsonValidate: '{\n   "A":""\n}',
      modelDisplayRouting: null,
      listValidation: [
        {
          key: "",
          typeValidation: "",
          numberOfCharacter: "",
          regExp: "",
          promptMessage: "",
        },
      ],
      nextRouting: null,
      isMergePrompt: true,
      actionType: "",
      isActionAnswer: false,
      activeFlag: true,
      botDisableTime: null,
    },
    DataRowUpload: [],
    DDActionType: [
      {
        name: "Document",
        value: "VT",
      },
      {
        name: "Text Response",
        value: "TR",
      },
      {
        name: "Model Routing",
        value: "MR",
      },
      {
        name: "Next Routing",
        value: "NR",
      },
      {
        name: "Contact Agent (Disable Bot)",
        value: "CA",
      },
      {
        name: "API Trigger",
        value: "AT",
      },
    ],
    DDTypeValidation: [
      {
        name: "Validation Phone",
        value: "PV",
      },
      {
        name: "Validation Email",
        value: "EV",
      },
      {
        name: "Validation Max Character",
        value: "MCV",
      },
      {
        name: "Validation Regular Expression",
        value: "RV",
      },
    ],
    DDMethod: ["GET", "POST", "PUT", "DELETE"],
    DDVector: [],
    uploadedFiles: [],
    entity: null,
    iconGoalsColor,
    iconGoalsWhite,
    iconActionOpen,
    iconActionClose,
    expandTop,
    expandDown,
  }),
  computed: {
    headers() {
      return [
        {
          text: "",
          align: "center",
          justify: "center",
          sortable: false,
          width: "10px",
        },
        {
          text: "text_org",
          value: "TextORG",
          align: "center",
          sortable: true,
          width: "50%",
        },
        {
          text: "text_en",
          value: "TextEN",
          align: "center",
          sortable: true,
          width: "50%",
        },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.GetByVector();
      },
      deep: true,
    },
  },
  methods: {
    showPopup() {
      this.showClipboardPopup = true;
      setTimeout(() => {
        this.showClipboardPopup = false;
      }, 2000);
    },
    CopyText(text) {
      navigator.clipboard.writeText(text);
      this.showPopup();
    },

    onDragStart(event, text) {
      event.dataTransfer.setData("text/plain", text);
      event.dataTransfer.effectAllowed = "copy";
    },

    onDragOver(event) {
      // event.preventDefault();
      event.dataTransfer.dropEffect = "copy";

      // เพิ่ม visual feedback
      const editor = event.target.closest(".prism-editor-wrapper");
      if (editor) {
        editor.classList.add("drag-over");
      }
    },

    onDragLeave(event) {
      // เอา visual feedback ออก
      const editor = event.target.closest(".prism-editor-wrapper");
      if (editor) {
        editor.classList.remove("drag-over");
      }
    },

    onDrop(event) {
      event.preventDefault();
      const text = event.dataTransfer.getData("text/plain");

      // หา prism-editor element
      const editor = event.target.closest(".prism-editor-wrapper");
      const textarea = editor?.querySelector("textarea");

      if (textarea) {
        // เอา visual feedback ออก
        editor.classList.remove("drag-over");

        // คำนวณตำแหน่งจาก mouse position
        const rect = textarea.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        // หาตำแหน่งใน textarea จากพิกัด mouse
        let position = 0;

        // ใช้ caretPositionFromPoint หรือ caretRangeFromPoint
        if (document.caretPositionFromPoint) {
          const caretPos = document.caretPositionFromPoint(
            event.clientX,
            event.clientY
          );
          if (caretPos && caretPos.offsetNode === textarea) {
            position = caretPos.offset;
          }
        } else if (document.caretRangeFromPoint) {
          const range = document.caretRangeFromPoint(
            event.clientX,
            event.clientY
          );
          if (range && range.startContainer === textarea) {
            position = range.startOffset;
          }
        } else {
          // Fallback: คำนวณตำแหน่งโดยประมาณ
          const lines = textarea.value.split("\n");
          const lineHeight =
            parseInt(getComputedStyle(textarea).lineHeight) || 20;
          const charWidth = 8; // ความกว้างโดยประมาณของตัวอักษร

          const lineIndex = Math.floor(y / lineHeight);
          const charIndex = Math.floor(x / charWidth);

          if (lineIndex < lines.length) {
            position = lines.slice(0, lineIndex).join("\n").length;
            if (lineIndex > 0) position += 1; // เพิ่ม newline
            position += Math.min(charIndex, lines[lineIndex]?.length || 0);
          } else {
            position = textarea.value.length;
          }
        }

        // แทรกข้อความที่ตำแหน่งที่คำนวณได้
        const currentValue = textarea.value;
        const newValue =
          currentValue.substring(0, position) +
          text +
          currentValue.substring(position);

        // หา action item ที่ตรงกัน และอัพเดต
        const editorId = editor.closest('[id^="codeEditor"]')?.id;
        if (editorId) {
          const indexMatch = editorId.match(/codeEditor-(\d+)/);
          if (indexMatch) {
            const actionIndex = parseInt(indexMatch[1]);
            const actions = this.Request.IntentActions.filter(
              (e) => e.activeFlag === true
            );
            if (actions[actionIndex]) {
              actions[actionIndex].jsonValidate = newValue;

              // ตั้งตำแหน่ง cursor หลังข้อความที่แทรก
              this.$nextTick(() => {
                const newPosition = position + text.length;
                textarea.setSelectionRange(newPosition, newPosition);
                textarea.focus();
              });
            }
          }
        }
      }
    },

    // ปรับปรุง insertVariable method
    insertVariable(text, indexs) {
      const editorId = `codeEditor-${indexs}`;
      const editor = document.getElementById(editorId);
      const textarea = editor?.querySelector("textarea");

      if (textarea) {
        const start = textarea.selectionStart || 0;
        const end = textarea.selectionEnd || 0;
        const currentValue = textarea.value;

        const newValue =
          currentValue.substring(0, start) + text + currentValue.substring(end);

        // อัพเดต model
        const actions = this.Request.IntentActions.filter(
          (e) => e.activeFlag === true
        );
        if (actions[indexs]) {
          actions[indexs].jsonValidate = newValue;
        }

        // ตั้งตำแหน่ง cursor
        this.$nextTick(() => {
          textarea.setSelectionRange(start + text.length, start + text.length);
          textarea.focus();
        });
      }
    },
    toggleAllMergePrompt() {
      // Set isMergePrompt for all IntentActions based on UseBasePrompt switch
      this.Request.IntentActions.forEach(action => {
        action.isMergePrompt = this.Request.UseBasePrompt;
      });
    },
    ChangeAction(IntentAction) {
      IntentAction.tblVector = "";
      IntentAction.prompt = "";
      IntentAction.textResponse = "";
      IntentAction.method = "";
      IntentAction.apiEndpoint = "";
      IntentAction.listHeadersAPITrigger = [
        {
          key: "",
          value: "",
        },
      ];
      IntentAction.listValidation = [
        {
          key: "",
          typeValidation: "",
          numberOfCharacter: "",
          regExp: "",
          promptMessage: "",
        },
      ];
      IntentAction.jsonValidate = '{\n   "A":""\n}';
      IntentAction.modelDisplayRouting = null;
      IntentAction.nextRouting = null;
      IntentAction.isMergePrompt = this.Request.UseBasePrompt;
      IntentAction.botDisableTime = "";
    },
    AddNewAction() {
      this.Request.IntentActions.push({
        intentActionID: "",
        tblVector: "",
        prompt: "",
        textResponse: "",
        method: "",
        apiEndpoint: "",
        listHeadersAPITrigger: [
          {
            key: "",
            value: "",
          },
        ],
        listValidation: [
          {
            key: "",
            typeValidation: "",
            numberOfCharacter: "",
            regExp: "",
            promptMessage: "",
          },
        ],
        jsonValidate: '{\n   "A":""\n}',
        modelDisplayRouting: null,
        nextRouting: null,
        isMergePrompt: this.Request.UseBasePrompt,
        actionType: "",
        isActionAnswer: this.Request.IntentActions.length == 0,
        activeFlag: true,
        vectorDetail: [],
        contactAgent: "",
        botDisableTime: "",
        // Show Parallel Action card only for actions added after the first one
        isParallelAction: this.Request.IntentActions.length > 0,
      });
    },
    AddHeader(item) {
      item.listHeadersAPITrigger.push({
        key: "",
        value: "",
      });
    },
    AddValidation(item) {
      item.listValidation.push({
        key: "",
        typeValidation: "",
        numberOfCharacter: "",
        regExp: "",
        promptMessage: "",
      });
    },
    DeleteAction(item, index) {
      item.activeFlag = false;
      if (item.intentActionID == 0) {
        this.Request.IntentActions.splice(index, 1);
      }
    },
    DeleteHeader(item, index, indexHeader) {
      if (item.listHeadersAPITrigger.length > 0) {
        this.Request.IntentActions[index].listHeadersAPITrigger.splice(
          indexHeader,
          1
        );
      }
    },
    DeleteValidation(item, index, indexValidation) {
      if (item.listValidation.length > 0) {
        this.Request.IntentActions[index].listValidation.splice(
          indexValidation,
          1
        );
      }
    },
    DeleteParallelAction(items) {
        items.isParallelAction = false;
        items.actionType = null;
        this.ChangeAction(items);
    },
    highlighter(code) {
      // ตรวจสอบว่าใช้ syntax นี้
      return highlight(code, languages.js);
    },
    formatText(text) {
      if (text === null || text === undefined) {
        return '';
      }
      return String(text).replace(/ /g, "&nbsp;");
    },
    DeleteVectorByBtn(IntentAction, Id) {
      let self = this;
      IntentAction.vectorDetail.splice(
        IntentAction.vectorDetail.findIndex((e) => e.tblVector == Id),
        1
      );
      if (self.Selected && Array.isArray(self.Selected[0])) {
        self.Selected[0] = self.Selected[0].filter((e) => e !== Id);
      }
      IntentAction.tblVector = self.Selected.join(",");
      self.dataTable.forEach((element) => {
        element.selected = false;
        var chk = self.Selected.find((e) => e == element.id);
        if (chk != undefined) {
          element.selected = true;
        }
      });
    },
    SelectVector(IntentAction, Flag, Id, TextORG) {
      let self = this;
      if (Flag) {
        self.Selected.push(Id);
        IntentAction.tblVector = self.Selected.join(",");
        if (IntentAction.vectorDetail != null) {
          IntentAction.vectorDetail.push({ textORG: TextORG, tblVector: Id });
        } else {
          IntentAction.vectorDetail = [{ textORG: TextORG, tblVector: Id }];
        }
      } else {
        if (self.Selected.indexOf(Id) > -1) {
          // Check if Id exists in Selected
          self.Selected.splice(self.Selected.indexOf(Id), 1);
          IntentAction.vectorDetail.splice(
            IntentAction.vectorDetail.findIndex((e) => e.tblVector == Id),
            1
          );
          IntentAction.tblVector = self.Selected.join(',');
        }
      }
    },
    CheckNewIntent(index) {
      let self = this;
      if (self.Intent.length == index + 1) {
        self.Intent.push({ text: "" });
      }
      return true;
    },
    CheckDeleteIntent(index, value) {
      let self = this;

      self.$nextTick(() => {
        const textareas = self.$refs.textareas;
        if (value == "" && index > 0 && self.Intent.length > 1) {
          self.Intent.splice(index, 1);
          if (textareas[index - 1]) {
            textareas[index - 1].focus();
          }
        }
        if (
          value == "" &&
          index <= self.Intent.length - 1 &&
          self.Intent.length > 1
        ) {
          self.Intent.splice(index, 1);
          if (textareas[index]) {
            textareas[index].focus();
          }
        }
      });
    },
    newLineEnter(index) {
      let self = this;
      if (self.Intent.length >= index + 1) {
        self.Intent.push({ text: "" });
      }
      //cursor
      self.$nextTick(() => {
        const textareas = self.$refs.textareas;
        if (textareas[index + 1]) {
          textareas[index + 1].focus();
        }
      });
    },
    DeleteIntent(index) {
      let self = this;
      if (self.Intent.length > 1) {
        self.Intent.splice(index, 1);
      }
    },
    onPaste(index, event) {
      let self = this;
      // event.preventDefault();
      const paste = event.clipboardData.getData("text");
      self.$set(self.Intent, index, { text: paste });
      if (self.Intent.length == index + 1) {
        self.Intent.push({ text: "" });
      }
    },
    getItemModelNameText(item) {
      return `${item.modelDisplayID}: ${item.name}`;
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModelDisplayName = dataResponse.data;
          } else {
            self.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async Get() {

      let self = this;
      self.dialog = true;
      self.$call.GetIntentSessionDetailById(
        self.id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dialog = false;
            self.Binding(dataResponse.data);
            
          }
          self.GetModel();
          self.GetDDVectorName();
          self.GetIntentGroup();
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetByVector() {
      let self = this;
      if (self.VectorName == "" || self.VectorName == null) {
        return;
      }
      self.dialog = true;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.VectorName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableVector(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.table.total;
            self.dataTable = dataResponse.data.table.data;
            self.totalTable = dataResponse.data.table.total;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
          self.ShowTable = true;
          self.dialog = false;
          self.dataTable.forEach((element) => {
            element.show = self.ShowAllText;
            element.selected = false;
            for (let index = 0; index < self.Selected.length; index++) {
              const element2 = self.Selected.find(
                (e) => e == element.id
              );
              if (element2 != undefined) {
                element.selected = true;
              }
            }
          });
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingTable = false;
          self.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    SaveAdd() {
      let self = this;
      if (!self.Request.Name || self.Request.Name.trim() === "") {
        self.showNameRequiredDialog = true;
        return;
      }
      // General validation for other fields
      if (self.validate()) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warningFillAll"),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.Prepare(1);
      
      try {
        self.dialog = true;
        self.$call.CreateIntentSession(
          self.Request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.successMessage = "Intent Session Saved Successfully !";
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 1500);
              self.$router.push({
                name: "IntentSession",
                query: {
                  id: self.Request.IntentGroupID,
                },
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.log("catch : AddIntentSession");
      }
    },
    SaveEdit() {
      let self = this;
      // Specific check for Name when editing as well
      if (!self.Request.Name || self.Request.Name.trim() === "") {
        self.showNameRequiredDialog = true;
        return;
      }
      if (self.validate()) {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warningFillAll"),
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.Prepare(2);
      try {
        self.dialog = true;
        self.$call.UpdateIntentSession(
          self.Request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
               this.successMessage = "Intent Session Updated Successfully !";
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 3000);
              self.$router.push({
                name: "IntentSession",
                query: {
                  id: self.Request.IntentGroupID,
                },
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.log("catch : UpdateIntentSession");
      }
    },
    Back() {
      this.$router.push({
        name: "IntentSession",
        query: {
          id: this.Request.IntentGroupID,
        },
      });
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    async GetIntentGroup() {
      let self = this;
      self.dialog = true;
      await self.$call.DDIntentGroup(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDIntentGroup = dataResponse.data;
          } else {
            self.listDDIntentGroup = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetDDVectorName() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDVectorDBName(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data;
          } else {
            self.DDVector = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    validate() {
      let self = this;
      if (
        self.Request.Name == "" ||
        self.Request.Name == null ||
        self.Request.PromptSession == "" ||
        self.Request.PromptSession == null ||
        self.Request.IntentActions == null ||
        self.Request.IntentActions.length == 0 ||
        self.validateAction()
      ) {
        return true;
      }
      self.Request.Score = self.Request.Score == "" ? null : self.Request.Score;
      return false;
    },
    validateAction() {
      let self = this;

      if (
        !self.Request.IntentActions ||
        !Array.isArray(self.Request.IntentActions)
      ) {
        return true;
      }
      let check = self.Request.IntentActions.filter(
        (e) => e.activeFlag == true
      );
      return check.some((action) => {
        return (
          (action.actionType == "VT" &&
            (action.tblVector == "" || action.tblVector == null)) ||
          (action.actionType == "TR" &&
            (action.textResponse == "" || action.textResponse == null)) ||
          (action.actionType == "MR" &&
            (action.modelDisplayRouting == "" ||
              action.modelDisplayRouting == null)) ||
          (action.actionType == "NR" &&
            (action.nextRouting == "" || action.nextRouting == null)) ||
          (action.actionType == "CA" &&
            (action.botDisableTime == "" || action.botDisableTime == null))
        );
      });
    },
    Prepare(v) {
      let self = this;
      self.Request.Intent = self.Intent.filter((e) => e.text !== "")
        .map((e) => e.text)
        .join(",");
      if(v == 1){
        if (self.Request.IntentActions.length > 1) {
          // Start from index 1 and filter out items with empty actionType
          const firstAction = self.Request.IntentActions[0];
          const restActions = self.Request.IntentActions.slice(1).filter(
            (action) => action.actionType !== "" && action.actionType !== null
          );
          self.Request.IntentActions = [firstAction, ...restActions];
        }
        self.Request.IntentActions.forEach(action => {
          if (action.botDisableTime === "" || action.botDisableTime === null) {
            action.botDisableTime = null;
          } else {
            action.botDisableTime = parseInt(action.botDisableTime) || null;
          }
        });
      } else {
        if (self.Request.IntentActions.length > 1) {
          const firstAction = self.Request.IntentActions[0];
    
          // Process actions from index 1 onwards
          const restActions = self.Request.IntentActions.slice(1).map(action => {
            // If both actionType and intentActionID are empty/null, mark for removal
            const shouldRemove = 
              (action.actionType === "" || action.actionType === null) &&
              (action.intentActionID === "" || action.intentActionID === null);
            
            // If actionType is empty but intentActionID exists, set activeFlag to false
            if ((action.actionType === "" || action.actionType === null) && 
                action.intentActionID !== "" && action.intentActionID !== null) {
              action.activeFlag = false;
            }
            
            return shouldRemove ? null : action;
          }).filter(action => action !== null); // Remove null items
          
          self.Request.IntentActions = [firstAction, ...restActions];
        }
        self.Request.IntentActions.forEach(action => {
          if (action.actionType == null || action.actionType == "") {
            action.actionType = "";
            action.listHeadersAPITrigger = [];
            action.listValidation = [];
          }
          if (action.botDisableTime === "" || action.botDisableTime === null) {
            action.botDisableTime = null;
          } else {
            action.botDisableTime = parseInt(action.botDisableTime) || null;
          }
        });
      }
    },
    Binding(Source) {
      let self = this;
      if (Source != null) {
        let intentArray = Source.intent.split(",");
        self.Intent = intentArray.map((intent) => ({ text: intent }));
        self.Intent.push({ text: "" });
        self.Request.Name = Source.name;
        self.Request.Score = Source.score;
        self.Request.UseMemory = Source.useMemory;
        self.Request.PromptSession = Source.promptSession;
        if (Source.intentAction.length > 0) {
          // self.Request.ActionType = Source.intentAction[0].actionType;
          // self.Request.Prompt = Source.intentAction[0].prompt;
          // self.Request.TextResponse = Source.intentAction[0].textResponse;
          // self.Request.ModelRouting = Source.intentAction[0].modelDisplayRouting;
          // self.Request.NextRouting = Source.intentAction[0].nextIntentGroupID;
          // self.Request.TBLVector = Source.intentAction[0].tblVector;
          // self.Request.IntentActionID = Source.intentAction[0].intentActionID;
          // self.Request.IsMergePrompt = Source.intentAction[0].isMergePrompt ?? false;
          // self.VectorDetail = Source.intentAction[0].vectorDetail ?? [];
          self.Request.IntentActions = Source.intentAction;
          const hasAnyMergePrompt = Source.intentAction.some(action => action.isMergePrompt === true);
          self.Request.UseBasePrompt = hasAnyMergePrompt;
          // self.Request.IntentActions.ListHeadersAPITrigger = Source.intentAction
          self.Request.IntentActions.forEach((element, index) => {
            element.isParallelAction = index > 0;
            if (element.actionType == "VT") {
              self.Selected[index] = element.tblVector.split(",").map(Number);
            }
          });
        }
      }
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isEnter: function (evt, index) {
      let self = this;
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 13) {
        evt.preventDefault();
      } else {
        self.CheckNewIntent(index);
        return true;
      }
    },
    downloadTemplate() {
      // สร้าง workbook และ worksheet ใหม่
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Template");

      // เพิ่มข้อมูลลงในเวิร์กชีต
      worksheet.addRow(["Intent text"]);
      worksheet.addRow(["หมีเนยคือใคร?"]);
      worksheet.addRow(["หมีเนยอายุเท่าไหร่?"]);
      worksheet.addRow(["สถานะภาพของหมีเนยคือ?"]);

      // ดาวน์โหลดไฟล์
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "intent_text_template.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    processUpload(event) {
      let self = this;      
      self.files = event;
      if (self.files.length === 0) {
        self.uploadedFiles = [];
        return;
      }

      const reader = new FileReader();
      const file = self.files[0];
      reader.onload = async (e) => {
        const workbook = new ExcelJS.Workbook();
        try {
          const buffer = e.target.result;
          await workbook.xlsx.load(buffer);

          // อ่านข้อมูลจาก worksheet แรก
          const worksheet = workbook.worksheets[0];
          const jsonData = [];

          // แปลงข้อมูลจาก worksheet เป็น array 2 มิติ
          worksheet.eachRow((row, rowNumber) => {
            const rowData = [];
            row.eachCell((cell) => {
              rowData.push(cell.value);
            });
            jsonData.push(rowData);
          });

          // ข้ามแถวแรกที่เป็นหัวข้อ
          self.DataRowUpload = jsonData.slice(1);
          self.ValidateFile(self.files);
          // self.ConfirmProcess();
          self.showConfirmDialog = true;
        } catch (error) {
          console.error("Error reading Excel file:", error);
          self.$swal.fire({
            icon: "error",
            title: "Error reading Excel file",
            text: "The file format is not supported or the file is corrupted.",
          });
        }
      };
      reader.readAsArrayBuffer(file);
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("upload_file", files[0]);
      self.uploadedFiles = files;
      self.entity = formDataDoc;
    },
    ConfirmProcess() {
      let self = this;
      const newData = self.DataRowUpload.map((row) => {
        return { text: row.join(" ") };
      });
      self.showConfirmDialog = true;
      if (self.Intent.length > 0) {
        self.Intent = self.Intent.filter(
          (item) => item.text.trim() !== ""
        );
        self.Intent = [...self.Intent, ...newData];
      } else {
        self.Intent = newData;
      }
      self.showConfirmDialog = false;

      // self.$swal
      //   .fire({
      //     title: this.$t("importIntentText"),
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonColor: "#3085d6",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: this.$t("yes"),
      //     cancelButtonText: this.$t("cancel"),
      //   })
      //   .then((result) => {
      //     if (result.isConfirmed) {
      //       const newData = self.DataRowUpload.map((row) => {
      //         return { text: row.join(" ") };
      //       });

      //       if (self.Intent.length > 0) {
      //         self.Intent = self.Intent.filter(
      //           (item) => item.text.trim() !== ""
      //         );
      //         // ถ้ามีข้อมูลอยู่แล้ว ให้ต่อข้อมูลใหม่เข้าไปใน Intent เดิม
      //         self.Intent = [...self.Intent, ...newData];
      //       } else {
      //         self.Intent = newData;
      //       }
      //     }
      //   });
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    if (self.$route.query.id) {
      self.id = self.$route.query.id;
      self.Request.IntentSessionID = self.$route.query.id;
      self.Request.IntentGroupID = self.$route.query.idGroup;
      await self.Get();
    } else if (self.$route.query.idGroup) {
      self.Request.IntentGroupID = self.$route.query.idGroup;
      self.AddEvent = true;
      await self.GetModel();
      await self.GetDDVectorName();
      await self.GetIntentGroup();
    }
    self.AddNewAction();
  },
};
</script>
<style scoped>
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #2ABF56 0%, #135928 100%) !important;
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}
.parallel-action-delete {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn-hover-none:hover {
  background: none !important;
}

.btn-hover-pink:hover {
  background: #FDE4DF !important;
}
.selected-chunks-design {
  display: flex;
  align-items: center !important;
  background: #ffffff !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(23,23,23,0.11) !important;
  padding: 6px !important;
  gap: 8px !important;
  width: 100px;
  overflow: hidden;
}
.chip-text-design {
  color: #171717;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60px;
  display: inline-block;
}
/* Confirm upload */
.confirm-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: linear-gradient(100deg, #E7EBFF 0%, #FFFFFF 100%) !important;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #001763;
}
.body-text {
  font-size: 12px;
  color: #171717;
}
.cancel-btn {
  border: 1px solid #949AA8;
  border-radius: 12px;
  height: 40px;
  padding: 4px 16px;
}
.confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px !important;
  width: 100px;
  height: 38px;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
}

.input-clearable {
  height: 50px;
}
.btn-action-design {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 108px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 8px;
}
.btn-action-design:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.validation-card {
  display: flex;
  flex-direction: row;
  padding: 12px;
}
.text-response {
  display: flex;
  align-items: center;
  gap: 6px;
}
.text-response-textarea {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  padding: 0 12px;
  color: #171717;
  margin-bottom: 16px;
}
.text-response-textarea::placeholder {
  color: #cccccc;
}
.intent-action-btn-wrapper {
  padding: 12px 18px;
}
.intent-action-btn {
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 12px;
  gap: 6px;
  background: #3859D0;
}
.intent-action-btn:hover {
  opacity: 0.7;
}
.intent-text {
  color: #FFFFFF;
  font-size: 14px;
}
.add-example-section {
  display: flex;
  align-items: center;
  border: 1px solid #C32E0E;
  border-radius: 8px;
  padding: 8px 12px;
  gap: 6px;
}
.add-example-section:hover {
  background: #FDE4DF;
}
.textarea-style {
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 10px;
  padding: 0 12px;
}
.heading-text {
  color: #171717;
  font-weight: 600;
}
.card-box {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding: 0px 12px;
}
.use-memory-card.state-on {
  background: #FFF2F2 !important;
}
.use-memory-card.state-off { 
  background: #EDEDED !important;
}
.cart-top {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}
.cart-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.col-control {
  display: flex;
  justify-content: start;
  align-items: center;
}
.action-divider {
  width: 2px;
  height: 72px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}
.intent-session-name{
  background: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  width: 40%;
  height: 44px;
  padding: 8px;
}
.intent-session-name:focus {
  border: 1px solid #c9c9c9;
  outline: 0px solid #c9c9c9;
}
.intent-session-name::placeholder {
  color: #CCCCCC;
}
.label-style {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.card2 {
  border: 1px solid rgba(201, 201, 201, 1) !important;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 10px;
}

/* Header Styling */
.header-title {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  border-radius: 16px 16px 0 0 !important;
}

/* Modern Expansion Panels */
.modern-panel {
  box-shadow: none !important;
  border-radius: 10px;
}

.panel-header {
  background: rgba(254, 225, 219, 1) !important;
  padding: 10px !important;
}
.intent-panel-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px !important;
  border-radius: 10px;
}
.intent-panel-open {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
}
.intent-panel-closed {
  background: rgba(254, 225, 219, 1) !important;
  color: #FFFFFF;
}
.intent-left {
  gap: 8px;
  display: flex;
  align-items: center;
}
.intent-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-design {
  border: 1px solid #C9C9C9;
  border-radius: 10px;
  box-shadow: none;
  background: #ffffff;
  margin-top: 8px;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  margin-bottom: 12px;
}
.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: start;
  margin-left: 8px;
}
.card-action-title {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: start;
}
.template-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 6px 16px !important;
  margin-top: 2px;
}
.template-btn:hover {
  background: #FDE4DF;
  box-shadow: none !important;
}
/* :deep(.UploadFile .upload-button img) {
  width: 36px !important;
  height: 36px !important;
} */
:deep(.UploadFile .upload-button) {
  gap: 4px;
  height: 35px;
  padding: 4px 16px !important;
}
:deep(.UploadFile .upload-button span) {
  font-size: 13px !important;
}
.UploadFile {
  padding: 4px 12px;
}
.panel-body {
  display: flex;
  align-items: center;
  gap: 8px;
}
.example-text, .action-text {
  font-size: 14px;
  font-weight: 600;
}

.header-text {
  font-size: 14px;
  font-weight: 600;
  color: #171717;
}

.panel-content {
  padding: 24px !important;
}

.transition-transform {
  transition: transform 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

/* Intent Container */
.intent-container {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
  border: none;
}

.intent-item {
  display: flex;
  align-items: flex-start;
  transition: background-color 0.2s ease;
}

.intent-item:hover {
  background-color: rgba(25, 118, 210, 0.02);
}

.intent-item:hover .delete-intent-btn {
  opacity: 1;
}

.intent-number {
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
  padding: 16px 20px;
  font-weight: 600;
  color: #666;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.intent-textarea {
  flex: 1;
  padding: 8px 16px;
}

.delete-intent-btn {
  opacity: 0;
  transition: opacity 0.2s ease;
  margin: 8px;
}

/* Action Cards */

.action-container {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
}

.action-section {
  padding: 0 18px;
  background: #ffffff;
  width: 100%;
  margin-top: 4px;
}

.action-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.action-type-badge {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.875rem;
}

.action-type-badge.action-answer {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
  color: white;
}

.action-type-badge.action-parallel {
  background: rgba(25, 118, 210, 0.1);
  color: #1976d2;
  border: 1px solid rgba(25, 118, 210, 0.3);
}

.action-type-text {
  font-weight: 600;
}

.delete-action-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.delete-action-btn:hover {
  opacity: 1;
}

/* Section Titles */
.section-title-simple {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1);
}

.section-title-simple .text-h6 {
  color: #1976d2;
  font-weight: 600;
}

/* Selected Vector Chips */
.selected-vectors {
  background: #EFF4FF;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #c9c9c9;
}

.selected-vector-chip {
  margin: 2px !important;
  font-weight: 500 !important;
}

/* Vector Table */
.vector-table {
  border-radius: 8px !important;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* JSON Editor */
.json-editor-container {
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.json-variables {
  background: #f8f9fa;
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.variables-header {
  margin-bottom: 8px;
  font-weight: 600;
  color: #666;
}

.variables-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.variable-chip {
  cursor: grab !important;
  position: relative;
  cursor: pointer !important;
}
.variable-chip:hover {
  background: rgba(56, 89, 208, 0.1) !important;
}
.variable-chip:active {
  background: rgba(56, 89, 208, 0.1) !important;
}

.modern-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: "Fira Code", "Fira Mono", Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  min-height: 200px;
}

/* Add Action Button */
.add-action-btn {
  border: 2px dashed #1976d2 !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border-radius: 12px !important;
  padding: 16px !important;
  transition: all 0.3s ease !important;
  width: 80px !important;
}

.add-action-btn:hover {
  background: rgba(25, 118, 210, 0.08) !important;
  transform: translateY(-2px);
}

.action-card-wrapper {
  position: relative;
}

.action-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: 2px solid transparent !important;
}

.action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.action-answer {
  background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%) !important;
  border-color: #9c27b0 !important;
}

.action-answer .action-title {
  color: white !important;
}

.action-parallel {
  background: white !important;
  border-color: #e0e0e0 !important;
}

.action-parallel .action-title {
  color: #1976d2 !important;
}

.action-title {
  padding: 20px 24px !important;
  border-radius: 16px 16px 0 0 !important;
  display: flex;
  align-items: center;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
}

/* Vector Table */
.vector-table {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.text-container {
  display: flex;
  align-items: flex-start;
  max-width: 100%;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
}

.text-content-show {
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
}

/* Selected Vector Chips */
/* .selected-vectors {
  background: rgba(25, 118, 210, 0.04);
  border-radius: 12px;
  padding: 16px;
} */

.selected-vector-chip {
  margin: 4px !important;
  font-weight: 500 !important;
}

/* API Sections */
.api-section {
  background: rgba(248, 249, 250, 0.5);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1976d2;
}

.header-row,
.validation-row {
  background: white;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* JSON Editor */
.json-editor-container {
  background: white;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.json-variables {
  background: #f8f9fa;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.variables-header {
  margin-bottom: 12px;
  font-weight: 600;
  color: #666;
}

.variables-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.modern-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: "Fira Code", "Fira Mono", Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  min-height: 200px;
}

/* Action Buttons */
.add-action-btn {
  border: 2px dashed #1976d2 !important;
  background: rgba(25, 118, 210, 0.02) !important;
  border-radius: 12px !important;
  padding: 16px !important;
  transition: all 0.3s ease !important;
}

.add-action-btn:hover {
  background: rgba(25, 118, 210, 0.08) !important;
  transform: translateY(-2px);
}

/* Form Controls */
:deep(.v-field) {
  border-radius: 8px !important;
}

:deep(.v-field--outlined) {
  border: 1.5px solid rgba(0, 0, 0, 0.12) !important;
}

:deep(.v-field--focused) {
  border-color: #1976d2 !important;
}

:deep(.v-input--density-comfortable) {
  --v-input-control-height: 48px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .panel-content {
    padding: 16px !important;
  }

  .action-title {
    padding: 16px !important;
    font-size: 1rem !important;
  }
  .action-section {
    padding: 16px;
  }

  .action-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .api-section {
    padding: 16px;
  }

  .variables-grid {
    flex-direction: column;
    gap: 4px;
  }

  .variable-chip {
    width: 100%;
    justify-content: center;
  }

  .modern-editor:deep(.prism-editor-wrapper.drag-over::before) {
    font-size: 10px;
    padding: 6px 12px;
  }
}

/* Animation for smooth transitions */
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}


@keyframes dragPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0);
  }
}

.modern-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: "Fira Code", "Fira Mono", Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  min-height: 200px;
  position: relative;
  transition: all 0.2s ease;
}

/* Drop zone styling */
.modern-editor:deep(.prism-editor-wrapper) {
  border: 2px solid transparent;
  transition: all 0.2s ease;
  position: relative;
}

.modern-editor:deep(.prism-editor-wrapper.drag-over) {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.08);
  box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.1);
}

.modern-editor:deep(.prism-editor-wrapper.drag-over::before) {
  content: "Drop variable here";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(25, 118, 210, 0.9);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
  pointer-events: none;
}
/* Variables grid improvements */
.variables-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}

.variables-header {
  margin-bottom: 12px;
  font-weight: 600;
  color: #666;
  font-size: 0.875rem;
}
.time-field-container {
  max-width: 300px;
}

.time-unit {
  font-size: 0.875rem;
  font-weight: 500;
}

.info-icon {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 1;
}


/* Selected Vector Chips */
.selected-vector-chip {
  margin: 4px !important;
  font-weight: 500 !important;
  display: inline-flex !important;
  align-items: center !important;
  max-width: 200px !important;
}

.selected-vector-chip .chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

/* ปรับแต่ง chip ให้แสดงปุ่ม close อย่างถูกต้อง */
.selected-vector-chip :deep(.v-chip__content) {
  display: flex !important;
  align-items: center !important;
  max-width: 100% !important;
  overflow: hidden !important;
}

.selected-vector-chip :deep(.v-chip__close) {
  flex-shrink: 0 !important;
  margin-left: 4px !important;
  order: 2 !important;
}

/* ปรับให้ข้อความไม่ไปทับปุ่ม close */
.selected-vector-chip :deep(.v-chip__content > span) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.example-questions-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
}

.example-input-row {
  display: flex;
  align-items: center;
  gap: 18px;
  background: #ffffff;
  padding: 6px 10px;
  min-height: 34px;
}


.example-info-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: #3859D0;
  background: rgba(56, 89, 208, 0.1);
  border-radius: 50%;
  flex-shrink: 0;
  user-select: none;
}

.example-input {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  border: 1px solid #DCDCDC;
  border-radius: 8px;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  color: #171717;
  background: #ffffff;
  padding: 4px 12px;
  height: 48px;
}

.example-input::placeholder {
  color: #cccccc;
  font-weight: 400;
}

/* .example-delete-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color .15s ease;
} */


@media (max-width: 600px) {
  .example-input-row {
    padding: 6px 8px;
    gap: 6px;
  }
  .example-info-icon { font-size: 10px; }
}

/* Required Name Dialog Styles */
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}

.required-name-header {
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 104px;
  background: #FFA726;
}

.required-name-dialog :deep(.v-divider) {
  border-color: #F4D6B8 !important;
}

.required-name-dialog .close-btn {
  color: #B45800;
}

.required-name-dialog .close-btn:hover {
  color: #8C3F00;
}

.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}

.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}

/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}

.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}

.memory-switch :deep(.v-switch__loader) { display: none !important; }
.v-input--density-default {
    --v-input-control-height: none;
}

/* Validation card styling */
.validation-item-card {
  border: 1px solid #E5E5E5;
  padding: 16px 18px 20px;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: none;
}

.validation-item-card .validation-label {
  font-size: 14px;
  font-weight: 400;
  color: #171717;
  display: inline-block;
  margin-bottom: 4px;
}

.validation-item-card :deep(.v-field) {
  border-radius: 10px !important;
}

.validation-item-card :deep(.v-textarea .v-field) {
  min-height: 90px;
}

/* Brown dropdown color (#872612) for Validation Type */
.validation-type-autocomplete :deep(.v-field__input) {
  font-size: 14px;
  color: #171717;
  font-weight: 500;
}

.validation-type-autocomplete :deep(.v-select__selection) {
  color: #171717 !important;
}

.validation-type-autocomplete :deep(.v-field__outline) {
  --v-field-border-color: #c9c9c9;
}

.validation-type-autocomplete :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  width: 40px;
  height: 40px;
}

.validation-type-autocomplete :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 600;
}

/* .validation-type-autocomplete :deep(.v-list .v-list-item--active) {
  background: rgba(135, 38, 18, 0.08) !important;
} */

.validation-type-autocomplete :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}

/* .validation-type-autocomplete :deep(.v-list .v-list-item:hover) {
  background: rgba(135, 38, 18, 0.05) !important;
} */

</style>